var _defs, _text, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _text2, _text3, _text4, _text5, _text6, _g10, _g11, _g12, _rect14, _path, _path2, _text7, _g13, _g14, _g15, _g16, _rect15, _rect16, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _g17, _path14, _path15, _g18, _g19, _g20, _g21, _g22, _g23;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlaceholder4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 780.471,
    height: 403.078,
    viewBox: "0 0 780.471 403.078",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1.47,
    y1: 0.5,
    x2: -0.714,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 6.939,
    y1: 0.5,
    x2: 2.291,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 6.576,
    y1: 0.5,
    x2: 2.707,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 3.684,
    y1: 0.526,
    x2: -0.114,
    y2: 0.495,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 5.605,
    y1: 0.488,
    x2: -1.264,
    y2: 0.504,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f44522"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -3.055,
    y1: 0.5,
    x2: 0.136,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -5.927,
    y1: 0.5,
    x2: -0.159,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 0.468,
    y1: 0.668,
    x2: 0.508,
    y2: 0.457,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 0.546,
    y1: 0.952,
    x2: 0.505,
    y2: 0.551,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: -273.517,
    y1: -15.651,
    x2: -271.962,
    y2: -15.651,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: -278.154,
    y1: -10.662,
    x2: -276.068,
    y2: -10.662,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: -7.203,
    y1: 0.5,
    x2: -0.29,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: -3.178,
    y1: 0.492,
    x2: 3.523,
    y2: 0.506,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: -2.835,
    y1: 0.5,
    x2: 1.582,
    y2: 0.5,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: -0.112,
    y1: 0.598,
    x2: 3.821,
    y2: -0.031,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 1.307,
    y1: 0.84,
    x2: 0.376,
    y2: 0.571,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 0.159,
    y1: 0.492,
    x2: 0.783,
    y2: 0.506,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.226,
    stopColor: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 0.509,
    y1: -0.053,
    x2: 0.433,
    y2: 0.92,
    xlinkHref: "#linear-gradient-5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_8542",
    "data-name": "\\uADF8\\uB8F9 8542",
    transform: "translate(-306.97 -578.907)"
  }, _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "\\uC9C0\\uC5F4_\\uD788\\uD2B8\\uB7A8\\uD504",
    "data-name": "\\uC9C0\\uC5F4 \\uD788\\uD2B8\\uB7A8\\uD504",
    transform: "translate(444.169 684.985)",
    fill: "#fff",
    fontSize: 17,
    fontFamily: "NanumGothicExtraBold, NanumGothic"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\uC9C0\uC5F4 \uD788\uD2B8\uB7A8\uD504"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_454",
    "data-name": "\\uC0AC\\uAC01\\uD615 454",
    width: 11,
    height: 80,
    transform: "translate(712.44 800.81) rotate(90)",
    fill: "url(#linear-gradient)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_455",
    "data-name": "\\uC0AC\\uAC01\\uD615 455",
    width: 11,
    height: 143,
    transform: "translate(634.44 800.81) rotate(90)",
    fill: "url(#linear-gradient-2)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_456",
    "data-name": "\\uC0AC\\uAC01\\uD615 456",
    width: 11,
    height: 131,
    transform: "translate(976.44 800.81) rotate(90)",
    fill: "url(#linear-gradient-3)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_457",
    "data-name": "\\uC0AC\\uAC01\\uD615 457",
    width: 11,
    height: 29,
    transform: "translate(1005.44 800.81) rotate(90)",
    fill: "url(#linear-gradient-4)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_458",
    "data-name": "\\uC0AC\\uAC01\\uD615 458",
    width: 11,
    height: 80,
    transform: "translate(845.44 800.81) rotate(90)",
    fill: "url(#linear-gradient-5)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_459",
    "data-name": "\\uC0AC\\uAC01\\uD615 459",
    width: 11,
    height: 78,
    transform: "translate(712.44 747.81) rotate(90)",
    fill: "url(#linear-gradient-6)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_460",
    "data-name": "\\uC0AC\\uAC01\\uD615 460",
    width: 11,
    height: 141,
    transform: "translate(632.44 747.81) rotate(90)",
    fill: "url(#linear-gradient-7)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_461",
    "data-name": "\\uC0AC\\uAC01\\uD615 461",
    width: 11,
    height: 38,
    transform: "translate(718.44 733.81) rotate(180)",
    fill: "url(#linear-gradient-8)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_462",
    "data-name": "\\uC0AC\\uAC01\\uD615 462",
    width: 11,
    height: 51,
    transform: "translate(718.44 695.81) rotate(180)",
    fill: "url(#linear-gradient-9)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_463",
    "data-name": "\\uC0AC\\uAC01\\uD615 463",
    width: 11,
    height: 38,
    transform: "translate(779.44 733.81) rotate(180)",
    fill: "url(#linear-gradient-10)"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_464",
    "data-name": "\\uC0AC\\uAC01\\uD615 464",
    width: 11,
    height: 51,
    transform: "translate(779.44 695.81) rotate(180)",
    fill: "url(#linear-gradient-11)"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_465",
    "data-name": "\\uC0AC\\uAC01\\uD615 465",
    width: 11,
    height: 169,
    transform: "translate(934.44 747.81) rotate(90)",
    fill: "url(#linear-gradient-12)"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_466",
    "data-name": "\\uC0AC\\uAC01\\uD615 466",
    width: 11,
    height: 70,
    transform: "translate(1005.44 747.81) rotate(90)",
    fill: "url(#linear-gradient-13)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1381",
    "data-name": "\\uADF8\\uB8F9 1381",
    transform: "translate(0 -6914)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1380",
    "data-name": "\\uADF8\\uB8F9 1380"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2899",
    "data-name": "\\uD328\\uC2A4 2899",
    d: "M731.12,7539.88v29.127a2.8,2.8,0,0,1-2.8,2.8H697.276a2.8,2.8,0,0,1-2.8-2.8V7539.88Z",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_467",
    "data-name": "\\uC0AC\\uAC01\\uD615 467",
    width: 26.885,
    height: 26.555,
    transform: "translate(726.074 7539.879) rotate(90)",
    fill: "#495968"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2900",
    "data-name": "\\uD328\\uC2A4 2900",
    d: "M726.074,7553.6v13.17H699.521V7553.6H706.6a2.5,2.5,0,1,1,2.434-3.078v-25.773h7.361v25.773a2.5,2.5,0,1,1,2.433,3.078Z",
    fill: "#569ec6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2901",
    "data-name": "\\uD328\\uC2A4 2901",
    d: "M707.506,7492.907a3.156,3.156,0,0,0-2.479,1.2h-9.316a3.164,3.164,0,1,0,0,3.925h2.7v5.212h3.925v-5.212h2.7a3.164,3.164,0,1,0,2.479-5.127Z",
    fill: "#495968"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2902",
    "data-name": "\\uD328\\uC2A4 2902",
    d: "M712.71,7508.079h-6.594a7.149,7.149,0,0,0-2-1.849h-7.488a7.148,7.148,0,0,0-2,1.849H682.368v8.438h12.254a7.118,7.118,0,0,0,11.494,0h2.375v8.227h8.438V7512.3A4.219,4.219,0,0,0,712.71,7508.079Z",
    fill: "#ff4b27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2903",
    "data-name": "\\uD328\\uC2A4 2903",
    d: "M704.113,7504.087a.841.841,0,0,0-.841-.841h-5.806a.841.841,0,0,0-.841.841v2.143h7.488Z",
    fill: "#ff4b27"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_468",
    "data-name": "\\uC0AC\\uAC01\\uD615 468",
    width: 21.911,
    height: 11.705,
    transform: "translate(657.113 7506.446)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2904",
    "data-name": "\\uD328\\uC2A4 2904",
    d: "M679.024,7504.082v16.433h3.344v-16.433Z",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1379",
    "data-name": "\\uADF8\\uB8F9 1379"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_469",
    "data-name": "\\uC0AC\\uAC01\\uD615 469",
    width: 16.075,
    height: 2.803,
    transform: "translate(704.672 7523.903)",
    fill: "#df5c39"
  }))), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_77",
    "data-name": "\\uC120 77",
    y2: 2.803,
    transform: "translate(720.747 7523.903)",
    fill: "#df5c39"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1382",
    "data-name": "\\uADF8\\uB8F9 1382",
    transform: "translate(0 -6914)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_470",
    "data-name": "\\uC0AC\\uAC01\\uD615 470",
    width: 34,
    height: 16,
    transform: "translate(695.441 7582.81)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_471",
    "data-name": "\\uC0AC\\uAC01\\uD615 471",
    width: 26,
    height: 10,
    rx: 2.529,
    transform: "translate(699.441 7585.81)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("text", {
    id: "T8",
    transform: "translate(707.493 7594.508)",
    fontSize: 9,
    fontFamily: "NanumGothicBold, NanumGothic"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "T8")))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1383",
    "data-name": "\\uADF8\\uB8F9 1383",
    transform: "translate(0 -6914)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_472",
    "data-name": "\\uC0AC\\uAC01\\uD615 472",
    width: 34,
    height: 16,
    transform: "translate(756.441 7582.81)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_473",
    "data-name": "\\uC0AC\\uAC01\\uD615 473",
    width: 26,
    height: 10,
    rx: 2.529,
    transform: "translate(760.441 7585.81)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("text", {
    id: "T7",
    transform: "translate(768.493 7594.508)",
    fontSize: 9,
    fontFamily: "NanumGothicBold, NanumGothic"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "T7")))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1384",
    "data-name": "\\uADF8\\uB8F9 1384",
    transform: "translate(0 -6914)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_474",
    "data-name": "\\uC0AC\\uAC01\\uD615 474",
    width: 34,
    height: 16,
    transform: "translate(831.441 7658.81)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_475",
    "data-name": "\\uC0AC\\uAC01\\uD615 475",
    width: 26,
    height: 10,
    rx: 2.529,
    transform: "translate(835.441 7661.81)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("text", {
    id: "T6",
    transform: "translate(843.493 7670.508)",
    fontSize: 9,
    fontFamily: "NanumGothicBold, NanumGothic"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "T6")))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1385",
    "data-name": "\\uADF8\\uB8F9 1385",
    transform: "translate(0 -6914)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_476",
    "data-name": "\\uC0AC\\uAC01\\uD615 476",
    width: 34,
    height: 16,
    transform: "translate(565.441 7658.81)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_477",
    "data-name": "\\uC0AC\\uAC01\\uD615 477",
    width: 26,
    height: 10,
    rx: 2.529,
    transform: "translate(569.441 7661.81)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("text", {
    id: "T4",
    transform: "translate(577.493 7670.508)",
    fontSize: 9,
    fontFamily: "NanumGothicBold, NanumGothic"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "T4")))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1386",
    "data-name": "\\uADF8\\uB8F9 1386",
    transform: "translate(0 -6914)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_478",
    "data-name": "\\uC0AC\\uAC01\\uD615 478",
    width: 34,
    height: 16,
    transform: "translate(831.441 7711.81)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_479",
    "data-name": "\\uC0AC\\uAC01\\uD615 479",
    width: 26,
    height: 10,
    rx: 2.529,
    transform: "translate(835.441 7714.81)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("text", {
    id: "T5",
    transform: "translate(843.493 7723.508)",
    fontSize: 9,
    fontFamily: "NanumGothicBold, NanumGothic"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "T5")))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1387",
    "data-name": "\\uADF8\\uB8F9 1387",
    transform: "translate(0 -6914)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_480",
    "data-name": "\\uC0AC\\uAC01\\uD615 480",
    width: 34,
    height: 16,
    transform: "translate(565.441 7711.81)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_481",
    "data-name": "\\uC0AC\\uAC01\\uD615 481",
    width: 26,
    height: 10,
    rx: 2.529,
    transform: "translate(569.441 7714.81)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("text", {
    id: "T3",
    transform: "translate(577.493 7723.508)",
    fontSize: 9,
    fontFamily: "NanumGothicBold, NanumGothic"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "T3")))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1405",
    "data-name": "\\uADF8\\uB8F9 1405",
    transform: "translate(0 -6914)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_482",
    "data-name": "\\uC0AC\\uAC01\\uD615 482",
    width: 13,
    height: 11,
    transform: "translate(767.441 7557.81)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1404",
    "data-name": "\\uADF8\\uB8F9 1404"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2905",
    "data-name": "\\uD328\\uC2A4 2905",
    d: "M796.468,7547.329H751.24a1.973,1.973,0,0,1-1.973-1.972v-7.734a1.972,1.972,0,0,1,1.973-1.972h45.228a1.971,1.971,0,0,1,1.973,1.972v7.734a1.972,1.972,0,0,1-1.973,1.972Z",
    fill: "#ed0611"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2906",
    "data-name": "\\uD328\\uC2A4 2906",
    d: "M773.854,7518.842a21.86,21.86,0,0,0-13.721,38.929l-1.054,2.707a.565.565,0,0,0,.288.718l8.422,3.929a.566.566,0,0,0,.736-.24l1.448-2.641a22.186,22.186,0,0,0,3.881.341,21.872,21.872,0,1,0,0-43.743ZM763.293,7561.3a.44.44,0,1,1-.213-.585A.439.439,0,0,1,763.293,7561.3Zm2.689,1.254a.44.44,0,1,1-.213-.584A.442.442,0,0,1,765.982,7562.557Z",
    fill: "#ff0714"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2907",
    "data-name": "\\uD328\\uC2A4 2907",
    d: "M793.065,7540.713a19.211,19.211,0,1,1-19.211-19.165A19.189,19.189,0,0,1,793.065,7540.713Z",
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2908",
    "data-name": "\\uD328\\uC2A4 2908",
    d: "M794.4,7538.334H782.163a.942.942,0,0,0-.632.228.635.635,0,0,0-.2.29l-1.61,5.1a6,6,0,0,1-11.738,0l-1.614-5.109a.7.7,0,0,0-.3-.367.973.973,0,0,0-.529-.149H753.313a20.434,20.434,0,0,1,.365-2.187,20.67,20.67,0,0,1,40.717,2.187Z",
    fill: "#e0e3d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2909",
    "data-name": "\\uD328\\uC2A4 2909",
    d: "M794.03,7536.147H782.163a3.142,3.142,0,0,0-2.082.776,2.851,2.851,0,0,0-.832,1.269l-1.657,5.256a3.813,3.813,0,0,1-7.474,0l-1.66-5.26a2.878,2.878,0,0,0-1.194-1.544,3.185,3.185,0,0,0-1.719-.5H753.678a20.671,20.671,0,0,1,40.352,0Z",
    fill: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_30",
    "data-name": "\\uD0C0\\uC6D0 30",
    cx: 3.319,
    cy: 3.319,
    r: 3.319,
    transform: "translate(770.535 7538.528)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_31",
    "data-name": "\\uD0C0\\uC6D0 31",
    cx: 1.77,
    cy: 1.77,
    r: 1.77,
    transform: "translate(772.084 7540.077)",
    fill: "#e2e2e2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1389",
    "data-name": "\\uADF8\\uB8F9 1389"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1388",
    "data-name": "\\uADF8\\uB8F9 1388"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2910",
    "data-name": "\\uD328\\uC2A4 2910",
    d: "M794.634,7538.381a20.663,20.663,0,0,0-.37-2.213,20.91,20.91,0,0,0-41.19,2.213,21.377,21.377,0,0,0-.128,2.332,20.908,20.908,0,1,0,41.816,0A21.362,21.362,0,0,0,794.634,7538.381Zm-20.78,21.5a19.166,19.166,0,1,1,19.211-19.167A19.189,19.189,0,0,1,773.854,7559.88Z",
    fill: "#ed0611"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1390",
    "data-name": "\\uADF8\\uB8F9 1390"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2911",
    "data-name": "\\uD328\\uC2A4 2911",
    d: "M787.076,7533.066l.3-1.319h.608v1.858h-.413v-1.333l-.3,1.333h-.413l-.326-1.314v1.314h-.382v-1.858h.608Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2912",
    "data-name": "\\uD328\\uC2A4 2912",
    d: "M788.808,7531.169a.136.136,0,0,0-.042-.117.235.235,0,0,0-.229,0,.109.109,0,0,0-.043.1v.082h-.287v-.07a.279.279,0,0,1,.115-.24.72.72,0,0,1,.675,0,.279.279,0,0,1,.115.24v.034a.257.257,0,0,1-.213.265.284.284,0,0,1,.164.1.28.28,0,0,1,.049.168v.1a.278.278,0,0,1-.115.24.72.72,0,0,1-.675,0,.278.278,0,0,1-.115-.24v-.107h.287v.119a.109.109,0,0,0,.043.1.2.2,0,0,0,.114.028.2.2,0,0,0,.115-.029.134.134,0,0,0,.042-.116v-.1a.152.152,0,0,0-.046-.127.247.247,0,0,0-.152-.037h-.1v-.184h.118a.253.253,0,0,0,.134-.03.114.114,0,0,0,.048-.106Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1397",
    "data-name": "\\uADF8\\uB8F9 1397"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_483",
    "data-name": "\\uC0AC\\uAC01\\uD615 483",
    width: 2.737,
    height: 3.079,
    transform: "translate(762.207 7530.659)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1391",
    "data-name": "\\uADF8\\uB8F9 1391"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2913",
    "data-name": "\\uD328\\uC2A4 2913",
    d: "M762.914,7531.67a.451.451,0,0,1,.17-.379.98.98,0,0,1,.982,0,.449.449,0,0,1,.17.379v1.057a.449.449,0,0,1-.17.379.98.98,0,0,1-.982,0,.451.451,0,0,1-.17-.379Zm.436,1.077a.18.18,0,0,0,.061.156.321.321,0,0,0,.329,0,.18.18,0,0,0,.061-.156v-1.1a.18.18,0,0,0-.061-.156.324.324,0,0,0-.329,0,.18.18,0,0,0-.061.156Z",
    fill: "#21201c"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_484",
    "data-name": "\\uC0AC\\uAC01\\uD615 484",
    width: 2.737,
    height: 3.079,
    transform: "translate(765.143 7530.659)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1392",
    "data-name": "\\uADF8\\uB8F9 1392"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2914",
    "data-name": "\\uD328\\uC2A4 2914",
    d: "M765.851,7531.67a.451.451,0,0,1,.17-.379.98.98,0,0,1,.982,0,.451.451,0,0,1,.17.379v1.057a.451.451,0,0,1-.17.379.98.98,0,0,1-.982,0,.451.451,0,0,1-.17-.379Zm.435,1.077a.181.181,0,0,0,.062.156.319.319,0,0,0,.328,0,.181.181,0,0,0,.062-.156v-1.1a.181.181,0,0,0-.062-.156.322.322,0,0,0-.328,0,.181.181,0,0,0-.062.156Z",
    fill: "#21201c"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_485",
    "data-name": "\\uC0AC\\uAC01\\uD615 485",
    width: 2.737,
    height: 3.079,
    transform: "translate(768.08 7530.659)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1393",
    "data-name": "\\uADF8\\uB8F9 1393"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2915",
    "data-name": "\\uD328\\uC2A4 2915",
    d: "M768.788,7531.67a.449.449,0,0,1,.17-.379.98.98,0,0,1,.982,0,.451.451,0,0,1,.17.379v1.057a.451.451,0,0,1-.17.379.98.98,0,0,1-.982,0,.449.449,0,0,1-.17-.379Zm.435,1.077a.18.18,0,0,0,.061.156.321.321,0,0,0,.329,0,.18.18,0,0,0,.061-.156v-1.1a.18.18,0,0,0-.061-.156.324.324,0,0,0-.329,0,.18.18,0,0,0-.061.156Z",
    fill: "#21201c"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_486",
    "data-name": "\\uC0AC\\uAC01\\uD615 486",
    width: 2.737,
    height: 3.079,
    transform: "translate(771.017 7530.659)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1394",
    "data-name": "\\uADF8\\uB8F9 1394"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2916",
    "data-name": "\\uD328\\uC2A4 2916",
    d: "M771.724,7531.67a.451.451,0,0,1,.17-.379.98.98,0,0,1,.982,0,.449.449,0,0,1,.17.379v1.057a.449.449,0,0,1-.17.379.98.98,0,0,1-.982,0,.451.451,0,0,1-.17-.379Zm.436,1.077a.18.18,0,0,0,.061.156.321.321,0,0,0,.329,0,.183.183,0,0,0,.061-.156v-1.1a.183.183,0,0,0-.061-.156.324.324,0,0,0-.329,0,.18.18,0,0,0-.061.156Z",
    fill: "#21201c"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_487",
    "data-name": "\\uC0AC\\uAC01\\uD615 487",
    width: 2.737,
    height: 3.079,
    transform: "translate(773.953 7530.659)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1395",
    "data-name": "\\uADF8\\uB8F9 1395"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2917",
    "data-name": "\\uD328\\uC2A4 2917",
    d: "M774.661,7531.67a.451.451,0,0,1,.17-.379.98.98,0,0,1,.982,0,.451.451,0,0,1,.17.379v1.057a.451.451,0,0,1-.17.379.98.98,0,0,1-.982,0,.451.451,0,0,1-.17-.379Zm.435,1.077a.181.181,0,0,0,.062.156.319.319,0,0,0,.328,0,.18.18,0,0,0,.061-.156v-1.1a.18.18,0,0,0-.061-.156.322.322,0,0,0-.328,0,.181.181,0,0,0-.062.156Z",
    fill: "#21201c"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_488",
    "data-name": "\\uC0AC\\uAC01\\uD615 488",
    width: 2.737,
    height: 3.079,
    transform: "translate(776.89 7530.659)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1396",
    "data-name": "\\uADF8\\uB8F9 1396"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2918",
    "data-name": "\\uD328\\uC2A4 2918",
    d: "M777.6,7531.67a.449.449,0,0,1,.171-.379.98.98,0,0,1,.982,0,.451.451,0,0,1,.17.379v1.057a.451.451,0,0,1-.17.379.98.98,0,0,1-.982,0,.449.449,0,0,1-.171-.379Zm.436,1.077a.18.18,0,0,0,.061.156.321.321,0,0,0,.329,0,.18.18,0,0,0,.061-.156v-1.1a.18.18,0,0,0-.061-.156.324.324,0,0,0-.329,0,.18.18,0,0,0-.061.156Z",
    fill: "#f14941"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_489",
    "data-name": "\\uC0AC\\uAC01\\uD615 489",
    width: 2.737,
    height: 3.079,
    transform: "translate(779.827 7530.659)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_490",
    "data-name": "\\uC0AC\\uAC01\\uD615 490",
    width: 2.737,
    height: 3.08,
    transform: "translate(782.764 7530.659)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_491",
    "data-name": "\\uC0AC\\uAC01\\uD615 491",
    width: 2.737,
    height: 0.429,
    transform: "translate(762.207 7530.659)",
    fill: "#cac8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_492",
    "data-name": "\\uC0AC\\uAC01\\uD615 492",
    width: 2.737,
    height: 0.429,
    transform: "translate(765.143 7530.659)",
    fill: "#cac8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_493",
    "data-name": "\\uC0AC\\uAC01\\uD615 493",
    width: 2.737,
    height: 0.429,
    transform: "translate(768.08 7530.659)",
    fill: "#cac8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_494",
    "data-name": "\\uC0AC\\uAC01\\uD615 494",
    width: 2.737,
    height: 0.429,
    transform: "translate(771.017 7530.659)",
    fill: "#cac8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_495",
    "data-name": "\\uC0AC\\uAC01\\uD615 495",
    width: 2.737,
    height: 0.429,
    transform: "translate(773.953 7530.659)",
    fill: "#cac8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_496",
    "data-name": "\\uC0AC\\uAC01\\uD615 496",
    width: 2.737,
    height: 0.429,
    transform: "translate(776.89 7530.659)",
    fill: "#cac8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_497",
    "data-name": "\\uC0AC\\uAC01\\uD615 497",
    width: 2.737,
    height: 0.429,
    transform: "translate(779.827 7530.659)",
    fill: "#cac8c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2919",
    "data-name": "\\uD328\\uC2A4 2919",
    d: "M781.4,7531.685a.235.235,0,0,0-.057-.184.231.231,0,0,0-.153-.048.239.239,0,0,0-.153.045.184.184,0,0,0-.058.155v.131h-.383v-.11a.476.476,0,0,1,.153-.38.841.841,0,0,1,.9,0,.476.476,0,0,1,.153.38v.052a.4.4,0,0,1-.284.418.387.387,0,0,1,.219.161.514.514,0,0,1,.065.266v.16a.474.474,0,0,1-.153.379.838.838,0,0,1-.9,0,.474.474,0,0,1-.153-.379v-.169h.383v.189a.186.186,0,0,0,.058.156.241.241,0,0,0,.153.045.234.234,0,0,0,.153-.047.229.229,0,0,0,.057-.183v-.16a.264.264,0,0,0-.063-.2.294.294,0,0,0-.2-.058h-.136v-.291h.159a.3.3,0,0,0,.179-.046.194.194,0,0,0,.064-.169Z",
    fill: "#f14941"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2920",
    "data-name": "\\uD328\\uC2A4 2920",
    d: "M784.576,7533.044a.839.839,0,0,0-.9,0,.478.478,0,0,0-.152.379v.11h.382v-.13a.185.185,0,0,1,.058-.155.232.232,0,0,1,.153-.047.219.219,0,0,1,.152.049.224.224,0,0,1,.058.184v.113a.2.2,0,0,1-.064.17.145.145,0,0,1-.042.022h.444a.454.454,0,0,0,.069-.263v-.053A.47.47,0,0,0,784.576,7533.044Z",
    fill: "#f14941"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2921",
    "data-name": "\\uD328\\uC2A4 2921",
    d: "M784.027,7530.659a.358.358,0,0,1-.048.051.377.377,0,0,1-.12.058.747.747,0,0,1-.186.02v.232h.3v1.586h.39v-1.947Z",
    fill: "#f14941"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2922",
    "data-name": "\\uD328\\uC2A4 2922",
    d: "M782.764,7530.659v.429H785.5v-.429Z",
    fill: "#cac8c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2923",
    "data-name": "\\uD328\\uC2A4 2923",
    d: "M784.363,7530.659v.429h-.389v-.068h-.3v-.233a.709.709,0,0,0,.186-.02.382.382,0,0,0,.119-.057.363.363,0,0,0,.049-.051Z",
    fill: "#b9362f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1398",
    "data-name": "\\uADF8\\uB8F9 1398"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2924",
    "data-name": "\\uD328\\uC2A4 2924",
    d: "M768.29,7528.71h-1.026l-.009-4.661h1.039Z",
    fill: "#191917"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_498",
    "data-name": "\\uC0AC\\uAC01\\uD615 498",
    width: 1.022,
    height: 4.661,
    transform: "translate(771.34 7524.049)",
    fill: "#191917"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_499",
    "data-name": "\\uC0AC\\uAC01\\uD615 499",
    width: 0.799,
    height: 4.661,
    transform: "translate(768.861 7524.049)",
    fill: "#191917"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2925",
    "data-name": "\\uD328\\uC2A4 2925",
    d: "M776.723,7528.71h-.784s.012-4.023,0-4.661h.786Z",
    fill: "#191917"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2926",
    "data-name": "\\uD328\\uC2A4 2926",
    d: "M774.393,7528.71h-.766s.012-3.108,0-4.661h.768Z",
    fill: "#191917"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2927",
    "data-name": "\\uD328\\uC2A4 2927",
    d: "M780.453,7528.71h-.562v-4.661h.561S780.447,7527.156,780.453,7528.71Z",
    fill: "#191917"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_500",
    "data-name": "\\uC0AC\\uAC01\\uD615 500",
    width: 0.548,
    height: 4.661,
    transform: "translate(770.24 7524.049)",
    fill: "#191917"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_501",
    "data-name": "\\uC0AC\\uAC01\\uD615 501",
    width: 0.551,
    height: 4.661,
    transform: "translate(777.943 7524.049)",
    fill: "#191917"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2928",
    "data-name": "\\uD328\\uC2A4 2928",
    d: "M779.419,7528.71h-.555c.005-1.554,0-4.661,0-4.661h.554Z",
    fill: "#191917"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_502",
    "data-name": "\\uC0AC\\uAC01\\uD615 502",
    width: 0.338,
    height: 4.661,
    transform: "translate(774.98 7524.049)",
    fill: "#191917"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_503",
    "data-name": "\\uC0AC\\uAC01\\uD615 503",
    width: 0.303,
    height: 4.661,
    transform: "translate(772.838 7524.049)",
    fill: "#191917"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_504",
    "data-name": "\\uC0AC\\uAC01\\uD615 504",
    width: 0.278,
    height: 4.661,
    transform: "translate(777.202 7524.049)",
    fill: "#191917"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1403",
    "data-name": "\\uADF8\\uB8F9 1403"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1400",
    "data-name": "\\uADF8\\uB8F9 1400"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_32",
    "data-name": "\\uD0C0\\uC6D0 32",
    cx: 2.82,
    cy: 2.82,
    r: 2.82,
    transform: "translate(783.178 7541.616)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2929",
    "data-name": "\\uD328\\uC2A4 2929",
    d: "M786,7542.838a1.6,1.6,0,0,0-1.021,2.827l-.287.763a.154.154,0,0,0,.1.185.145.145,0,0,0,.183-.024l.518-.64a1.6,1.6,0,1,0,.51-3.111Z",
    fill: "#f22723"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1399",
    "data-name": "\\uADF8\\uB8F9 1399"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2930",
    "data-name": "\\uD328\\uC2A4 2930",
    d: "M786,7548.155a3.672,3.672,0,0,1-.458-.028l.043-.354a3.5,3.5,0,0,0,.67.016l.026.356C786.186,7548.152,786.093,7548.155,786,7548.155Zm.649-.056-.062-.352a3.425,3.425,0,0,0,.644-.181l.131.332A3.769,3.769,0,0,1,786.647,7548.1Zm-1.472-.035a3.8,3.8,0,0,1-.7-.235l.147-.326a3.342,3.342,0,0,0,.634.213Zm2.522-.319-.163-.318a3.331,3.331,0,0,0,.562-.363l.223.279A3.753,3.753,0,0,1,787.7,7547.745Zm-3.555-.085a3.73,3.73,0,0,1-.6-.432l.236-.268a3.447,3.447,0,0,0,.544.391Zm4.454-.563-.249-.255a3.378,3.378,0,0,0,.43-.513l.3.2A3.7,3.7,0,0,1,788.6,7547.1Zm-5.321-.127a3.773,3.773,0,0,1-.448-.589l.3-.187a3.334,3.334,0,0,0,.406.532Zm5.99-.756-.313-.171a3.359,3.359,0,0,0,.26-.617l.341.106A3.735,3.735,0,0,1,789.265,7546.214Zm-6.616-.158a3.662,3.662,0,0,1-.254-.7l.345-.089a3.4,3.4,0,0,0,.23.628Zm6.995-.884-.35-.07a3.373,3.373,0,0,0,.066-.666l.357-.015v.015A3.692,3.692,0,0,1,789.644,7545.172Zm-7.323-.175a3.761,3.761,0,0,1-.042-.561c0-.06,0-.119,0-.178l.356.017c0,.054,0,.107,0,.161a3.311,3.311,0,0,0,.038.508Zm7.021-.91a3.326,3.326,0,0,0-.134-.655l.341-.106a3.718,3.718,0,0,1,.148.725Zm-6.67-.145-.353-.052a3.62,3.62,0,0,1,.18-.719l.336.122A3.265,3.265,0,0,0,782.672,7543.942Zm6.42-.824a3.293,3.293,0,0,0-.323-.586l.294-.2a3.632,3.632,0,0,1,.357.649Zm-6.128-.134-.322-.154a3.726,3.726,0,0,1,.386-.633l.285.215A3.415,3.415,0,0,0,782.964,7542.984Zm5.6-.718a3.327,3.327,0,0,0-.481-.466l.222-.28a3.745,3.745,0,0,1,.532.515Zm-5.039-.111-.262-.242a3.685,3.685,0,0,1,.554-.491l.209.289A3.425,3.425,0,0,0,783.527,7542.155Zm4.285-.55a3.343,3.343,0,0,0-.6-.3l.129-.333a3.8,3.8,0,0,1,.66.336Zm-3.5-.077-.18-.309a3.723,3.723,0,0,1,.674-.306l.115.338A3.408,3.408,0,0,0,784.309,7541.528Zm2.589-.332a3.37,3.37,0,0,0-.659-.114l.025-.356a3.671,3.671,0,0,1,.729.126Zm-1.658-.037-.08-.348a3.764,3.764,0,0,1,.734-.093l.01.357A3.32,3.32,0,0,0,785.24,7541.159Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1402",
    "data-name": "\\uADF8\\uB8F9 1402"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2931",
    "data-name": "\\uD328\\uC2A4 2931",
    d: "M762.771,7544.8a1.106,1.106,0,0,0,0-.719,8.371,8.371,0,0,0,2.014-1.416,8.33,8.33,0,0,0-2.234,1.036,1.123,1.123,0,0,0-.623-.36,8.3,8.3,0,0,0-.219-2.451,8.347,8.347,0,0,0-.219,2.451,1.13,1.13,0,0,0-.623.36,8.333,8.333,0,0,0-2.233-1.036,8.346,8.346,0,0,0,2.014,1.416,1.106,1.106,0,0,0,0,.719,8.346,8.346,0,0,0-2.014,1.416,8.345,8.345,0,0,0,2.233-1.036,1.116,1.116,0,0,0,.623.36,8.358,8.358,0,0,0,.219,2.452,8.313,8.313,0,0,0,.219-2.452,1.11,1.11,0,0,0,.623-.36,8.343,8.343,0,0,0,2.234,1.036A8.371,8.371,0,0,0,762.771,7544.8Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1401",
    "data-name": "\\uADF8\\uB8F9 1401"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2932",
    "data-name": "\\uD328\\uC2A4 2932",
    d: "M761.709,7548.155a3.719,3.719,0,1,1,3.719-3.718A3.722,3.722,0,0,1,761.709,7548.155Zm0-7.279a3.561,3.561,0,1,0,3.561,3.561A3.564,3.564,0,0,0,761.709,7540.876Z"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_505",
    "data-name": "\\uC0AC\\uAC01\\uD615 505",
    width: 12.243,
    height: 1.918,
    transform: "translate(767.733 7551.798)",
    fill: "#e8ebdd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_506",
    "data-name": "\\uC0AC\\uAC01\\uD615 506",
    width: 11.063,
    height: 1.918,
    transform: "translate(768.323 7554.509)",
    fill: "#e8ebdd"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1417",
    "data-name": "\\uADF8\\uB8F9 1417",
    transform: "translate(0 -6914)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1416",
    "data-name": "\\uADF8\\uB8F9 1416"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1408",
    "data-name": "\\uADF8\\uB8F9 1408"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1406",
    "data-name": "\\uADF8\\uB8F9 1406"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_507",
    "data-name": "\\uC0AC\\uAC01\\uD615 507",
    width: 7.828,
    height: 28.726,
    transform: "translate(678.539 7838.881)",
    fill: "#8d8e8e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1407",
    "data-name": "\\uADF8\\uB8F9 1407"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_508",
    "data-name": "\\uC0AC\\uAC01\\uD615 508",
    width: 7.834,
    height: 28.726,
    transform: "translate(803.849 7838.881)",
    fill: "#8d8e8e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1409",
    "data-name": "\\uADF8\\uB8F9 1409"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2933",
    "data-name": "\\uD328\\uC2A4 2933",
    d: "M802.508,7838.881c0-6.168-25.7-11.17-57.4-11.17s-57.391,5-57.391,11.17,25.7,11.169,57.391,11.169S802.508,7845.049,802.508,7838.881Z",
    fill: "#cdcdcd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1410",
    "data-name": "\\uADF8\\uB8F9 1410"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2934",
    "data-name": "\\uD328\\uC2A4 2934",
    d: "M814.032,7644.651c0-7.407-30.861-13.411-68.925-13.411s-68.916,6-68.916,13.411,30.856,13.411,68.916,13.411S814.032,7652.059,814.032,7644.651Z",
    fill: "#cdcdcd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1415",
    "data-name": "\\uADF8\\uB8F9 1415"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1411",
    "data-name": "\\uADF8\\uB8F9 1411"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_509",
    "data-name": "\\uC0AC\\uAC01\\uD615 509",
    width: 137.841,
    height: 194.26,
    transform: "translate(676.191 7644.651)",
    fill: "#9b9c9c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1412",
    "data-name": "\\uADF8\\uB8F9 1412"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_510",
    "data-name": "\\uC0AC\\uAC01\\uD615 510",
    width: 137.841,
    height: 191.403,
    transform: "translate(676.191 7647.507)",
    fill: "#d5d5d5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1413",
    "data-name": "\\uADF8\\uB8F9 1413"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_511",
    "data-name": "\\uC0AC\\uAC01\\uD615 511",
    width: 6.966,
    height: 191.389,
    transform: "translate(679.671 7647.492)",
    fill: "#eaeaea"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1414",
    "data-name": "\\uADF8\\uB8F9 1414"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_512",
    "data-name": "\\uC0AC\\uAC01\\uD615 512",
    width: 3.486,
    height: 191.389,
    transform: "translate(690.779 7647.492)",
    fill: "#eaeaea"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2935",
    "data-name": "\\uD328\\uC2A4 2935",
    d: "M811.5,7866.765h-7.47l-4.166,7.559h15.8Z",
    fill: "#8d8e8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2936",
    "data-name": "\\uD328\\uC2A4 2936",
    d: "M686.183,7866.765h-7.468l-4.166,7.559h15.807Z",
    fill: "#8d8e8e"
  })))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    id: "\\uC801\\uC0B0\\uC5F4\\uB7C9\\uACC4",
    transform: "translate(885.169 856.985)",
    fill: "#fff",
    fontSize: 17,
    fontFamily: "NanumGothicExtraBold, NanumGothic"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\uC801\uC0B0\uC5F4\uB7C9\uACC4"))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    id: "\\uB0C9\\uB09C\\uBC29",
    transform: "translate(1014.169 856.985)",
    fill: "#fff",
    fontSize: 17,
    fontFamily: "NanumGothicExtraBold, NanumGothic"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\uB0C9\uB09C\uBC29"))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    id: "\\uB0C9_\\uC628\\uC218_\\uCD95\\uC5F4\\uC870",
    "data-name": "\\uB0C9/\\uC628\\uC218 \\uCD95\\uC5F4\\uC870",
    transform: "translate(692.169 978.985)",
    fill: "#fff",
    fontSize: 17,
    fontFamily: "NanumGothicExtraBold, NanumGothic"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\uB0C9/\uC628\uC218 \uCD95\uC5F4\uC870"))), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    id: "\\uC801\\uC0B0\\uC5F4\\uB7C9\\uACC4-2",
    "data-name": "\\uC801\\uC0B0\\uC5F4\\uB7C9\\uACC4",
    transform: "translate(734.169 596.985)",
    fill: "#fff",
    fontSize: 17,
    fontFamily: "NanumGothicExtraBold, NanumGothic"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\uC801\uC0B0\uC5F4\uB7C9\uACC4"))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    id: "\\uAE09\\uD0D5",
    transform: "translate(620.169 600.985)",
    fill: "#fff",
    fontSize: 17,
    fontFamily: "NanumGothicExtraBold, NanumGothic"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\uAE09\uD0D5"))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1435",
    "data-name": "\\uADF8\\uB8F9 1435",
    transform: "translate(0 -6914)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_513",
    "data-name": "\\uC0AC\\uAC01\\uD615 513",
    width: 13,
    height: 11,
    transform: "translate(956.44 7714.033) rotate(90)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_514",
    "data-name": "\\uC0AC\\uAC01\\uD615 514",
    width: 13,
    height: 11,
    transform: "translate(905.44 7714.033) rotate(90)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1434",
    "data-name": "\\uADF8\\uB8F9 1434"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2937",
    "data-name": "\\uD328\\uC2A4 2937",
    d: "M947.468,7726.329H902.24a1.973,1.973,0,0,1-1.973-1.972v-7.734a1.972,1.972,0,0,1,1.973-1.972h45.228a1.971,1.971,0,0,1,1.973,1.972v7.734a1.972,1.972,0,0,1-1.973,1.972Z",
    fill: "#ed0611"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2938",
    "data-name": "\\uD328\\uC2A4 2938",
    d: "M924.854,7697.842a21.86,21.86,0,0,0-13.721,38.929l-1.054,2.707a.565.565,0,0,0,.288.718l8.422,3.929a.566.566,0,0,0,.736-.24l1.448-2.641a22.186,22.186,0,0,0,3.881.341,21.872,21.872,0,1,0,0-43.743ZM914.293,7740.3a.44.44,0,1,1-.213-.585A.439.439,0,0,1,914.293,7740.3Zm2.689,1.254a.44.44,0,1,1-.213-.584A.442.442,0,0,1,916.982,7741.557Z",
    fill: "#ff0714"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2939",
    "data-name": "\\uD328\\uC2A4 2939",
    d: "M944.065,7719.713a19.211,19.211,0,1,1-19.211-19.165A19.189,19.189,0,0,1,944.065,7719.713Z",
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2940",
    "data-name": "\\uD328\\uC2A4 2940",
    d: "M945.4,7717.334H933.163a.942.942,0,0,0-.632.228.635.635,0,0,0-.2.29l-1.61,5.1a6,6,0,0,1-11.738,0l-1.614-5.109a.7.7,0,0,0-.3-.367.973.973,0,0,0-.529-.149H904.313a20.434,20.434,0,0,1,.365-2.187,20.67,20.67,0,0,1,40.717,2.187Z",
    fill: "#e0e3d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2941",
    "data-name": "\\uD328\\uC2A4 2941",
    d: "M945.03,7715.147H933.163a3.142,3.142,0,0,0-2.082.776,2.851,2.851,0,0,0-.832,1.269l-1.657,5.256a3.813,3.813,0,0,1-7.474,0l-1.66-5.26a2.878,2.878,0,0,0-1.194-1.544,3.185,3.185,0,0,0-1.719-.5H904.678a20.671,20.671,0,0,1,40.352,0Z",
    fill: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_33",
    "data-name": "\\uD0C0\\uC6D0 33",
    cx: 3.319,
    cy: 3.319,
    r: 3.319,
    transform: "translate(921.535 7717.528)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_34",
    "data-name": "\\uD0C0\\uC6D0 34",
    cx: 1.77,
    cy: 1.77,
    r: 1.77,
    transform: "translate(923.084 7719.077)",
    fill: "#e2e2e2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1419",
    "data-name": "\\uADF8\\uB8F9 1419"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1418",
    "data-name": "\\uADF8\\uB8F9 1418"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2942",
    "data-name": "\\uD328\\uC2A4 2942",
    d: "M945.634,7717.381a20.663,20.663,0,0,0-.37-2.213,20.91,20.91,0,0,0-41.19,2.213,21.377,21.377,0,0,0-.128,2.332,20.908,20.908,0,1,0,41.816,0A21.362,21.362,0,0,0,945.634,7717.381Zm-20.78,21.5a19.166,19.166,0,1,1,19.211-19.167A19.189,19.189,0,0,1,924.854,7738.88Z",
    fill: "#ed0611"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1420",
    "data-name": "\\uADF8\\uB8F9 1420"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2943",
    "data-name": "\\uD328\\uC2A4 2943",
    d: "M938.076,7712.066l.3-1.319h.608v1.858h-.413v-1.333l-.3,1.333h-.413l-.326-1.314v1.314h-.382v-1.858h.608Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2944",
    "data-name": "\\uD328\\uC2A4 2944",
    d: "M939.808,7710.169a.136.136,0,0,0-.042-.117.235.235,0,0,0-.229,0,.109.109,0,0,0-.043.1v.082h-.287v-.07a.279.279,0,0,1,.115-.24.72.72,0,0,1,.675,0,.279.279,0,0,1,.115.24v.034a.257.257,0,0,1-.213.265.284.284,0,0,1,.164.1.28.28,0,0,1,.049.168v.1a.278.278,0,0,1-.115.24.72.72,0,0,1-.675,0,.278.278,0,0,1-.115-.24v-.107h.287v.119a.109.109,0,0,0,.043.1.2.2,0,0,0,.114.028.2.2,0,0,0,.115-.029.134.134,0,0,0,.042-.116v-.1a.152.152,0,0,0-.046-.127.247.247,0,0,0-.152-.037h-.1v-.184h.118a.253.253,0,0,0,.134-.03.114.114,0,0,0,.048-.106Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1427",
    "data-name": "\\uADF8\\uB8F9 1427"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_515",
    "data-name": "\\uC0AC\\uAC01\\uD615 515",
    width: 2.737,
    height: 3.079,
    transform: "translate(913.207 7709.659)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1421",
    "data-name": "\\uADF8\\uB8F9 1421"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2945",
    "data-name": "\\uD328\\uC2A4 2945",
    d: "M913.914,7710.67a.451.451,0,0,1,.17-.379.98.98,0,0,1,.982,0,.449.449,0,0,1,.17.379v1.057a.449.449,0,0,1-.17.379.98.98,0,0,1-.982,0,.451.451,0,0,1-.17-.379Zm.436,1.077a.18.18,0,0,0,.061.156.321.321,0,0,0,.329,0,.18.18,0,0,0,.061-.156v-1.1a.18.18,0,0,0-.061-.156.324.324,0,0,0-.329,0,.18.18,0,0,0-.061.156Z",
    fill: "#21201c"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_516",
    "data-name": "\\uC0AC\\uAC01\\uD615 516",
    width: 2.737,
    height: 3.079,
    transform: "translate(916.143 7709.659)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1422",
    "data-name": "\\uADF8\\uB8F9 1422"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2946",
    "data-name": "\\uD328\\uC2A4 2946",
    d: "M916.851,7710.67a.451.451,0,0,1,.17-.379.98.98,0,0,1,.982,0,.451.451,0,0,1,.17.379v1.057a.451.451,0,0,1-.17.379.98.98,0,0,1-.982,0,.451.451,0,0,1-.17-.379Zm.435,1.077a.181.181,0,0,0,.062.156.319.319,0,0,0,.328,0,.181.181,0,0,0,.062-.156v-1.1a.181.181,0,0,0-.062-.156.322.322,0,0,0-.328,0,.181.181,0,0,0-.062.156Z",
    fill: "#21201c"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_517",
    "data-name": "\\uC0AC\\uAC01\\uD615 517",
    width: 2.737,
    height: 3.079,
    transform: "translate(919.08 7709.659)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1423",
    "data-name": "\\uADF8\\uB8F9 1423"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2947",
    "data-name": "\\uD328\\uC2A4 2947",
    d: "M919.788,7710.67a.449.449,0,0,1,.17-.379.98.98,0,0,1,.982,0,.451.451,0,0,1,.17.379v1.057a.451.451,0,0,1-.17.379.98.98,0,0,1-.982,0,.449.449,0,0,1-.17-.379Zm.435,1.077a.18.18,0,0,0,.061.156.321.321,0,0,0,.329,0,.18.18,0,0,0,.061-.156v-1.1a.18.18,0,0,0-.061-.156.324.324,0,0,0-.329,0,.18.18,0,0,0-.061.156Z",
    fill: "#21201c"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_518",
    "data-name": "\\uC0AC\\uAC01\\uD615 518",
    width: 2.737,
    height: 3.079,
    transform: "translate(922.017 7709.659)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1424",
    "data-name": "\\uADF8\\uB8F9 1424"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2948",
    "data-name": "\\uD328\\uC2A4 2948",
    d: "M922.724,7710.67a.451.451,0,0,1,.17-.379.98.98,0,0,1,.982,0,.449.449,0,0,1,.17.379v1.057a.449.449,0,0,1-.17.379.98.98,0,0,1-.982,0,.451.451,0,0,1-.17-.379Zm.436,1.077a.18.18,0,0,0,.061.156.321.321,0,0,0,.329,0,.183.183,0,0,0,.061-.156v-1.1a.183.183,0,0,0-.061-.156.324.324,0,0,0-.329,0,.18.18,0,0,0-.061.156Z",
    fill: "#21201c"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_519",
    "data-name": "\\uC0AC\\uAC01\\uD615 519",
    width: 2.737,
    height: 3.079,
    transform: "translate(924.953 7709.659)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1425",
    "data-name": "\\uADF8\\uB8F9 1425"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2949",
    "data-name": "\\uD328\\uC2A4 2949",
    d: "M925.661,7710.67a.451.451,0,0,1,.17-.379.98.98,0,0,1,.982,0,.451.451,0,0,1,.17.379v1.057a.451.451,0,0,1-.17.379.98.98,0,0,1-.982,0,.451.451,0,0,1-.17-.379Zm.435,1.077a.181.181,0,0,0,.062.156.319.319,0,0,0,.328,0,.18.18,0,0,0,.061-.156v-1.1a.18.18,0,0,0-.061-.156.322.322,0,0,0-.328,0,.181.181,0,0,0-.062.156Z",
    fill: "#21201c"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_520",
    "data-name": "\\uC0AC\\uAC01\\uD615 520",
    width: 2.737,
    height: 3.079,
    transform: "translate(927.89 7709.659)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1426",
    "data-name": "\\uADF8\\uB8F9 1426"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2950",
    "data-name": "\\uD328\\uC2A4 2950",
    d: "M928.6,7710.67a.449.449,0,0,1,.171-.379.98.98,0,0,1,.982,0,.451.451,0,0,1,.17.379v1.057a.451.451,0,0,1-.17.379.98.98,0,0,1-.982,0,.449.449,0,0,1-.171-.379Zm.436,1.077a.18.18,0,0,0,.061.156.321.321,0,0,0,.329,0,.18.18,0,0,0,.061-.156v-1.1a.18.18,0,0,0-.061-.156.324.324,0,0,0-.329,0,.18.18,0,0,0-.061.156Z",
    fill: "#f14941"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_521",
    "data-name": "\\uC0AC\\uAC01\\uD615 521",
    width: 2.737,
    height: 3.079,
    transform: "translate(930.827 7709.659)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_522",
    "data-name": "\\uC0AC\\uAC01\\uD615 522",
    width: 2.737,
    height: 3.08,
    transform: "translate(933.764 7709.659)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_523",
    "data-name": "\\uC0AC\\uAC01\\uD615 523",
    width: 2.737,
    height: 0.429,
    transform: "translate(913.207 7709.659)",
    fill: "#cac8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_524",
    "data-name": "\\uC0AC\\uAC01\\uD615 524",
    width: 2.737,
    height: 0.429,
    transform: "translate(916.143 7709.659)",
    fill: "#cac8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_525",
    "data-name": "\\uC0AC\\uAC01\\uD615 525",
    width: 2.737,
    height: 0.429,
    transform: "translate(919.08 7709.659)",
    fill: "#cac8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_526",
    "data-name": "\\uC0AC\\uAC01\\uD615 526",
    width: 2.737,
    height: 0.429,
    transform: "translate(922.017 7709.659)",
    fill: "#cac8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_527",
    "data-name": "\\uC0AC\\uAC01\\uD615 527",
    width: 2.737,
    height: 0.429,
    transform: "translate(924.953 7709.659)",
    fill: "#cac8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_528",
    "data-name": "\\uC0AC\\uAC01\\uD615 528",
    width: 2.737,
    height: 0.429,
    transform: "translate(927.89 7709.659)",
    fill: "#cac8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_529",
    "data-name": "\\uC0AC\\uAC01\\uD615 529",
    width: 2.737,
    height: 0.429,
    transform: "translate(930.827 7709.659)",
    fill: "#cac8c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2951",
    "data-name": "\\uD328\\uC2A4 2951",
    d: "M932.4,7710.685a.235.235,0,0,0-.057-.184.231.231,0,0,0-.153-.048.239.239,0,0,0-.153.045.184.184,0,0,0-.058.155v.131h-.383v-.11a.476.476,0,0,1,.153-.38.841.841,0,0,1,.9,0,.476.476,0,0,1,.153.38v.052a.4.4,0,0,1-.284.418.387.387,0,0,1,.219.161.514.514,0,0,1,.065.266v.16a.474.474,0,0,1-.153.379.838.838,0,0,1-.9,0,.474.474,0,0,1-.153-.379v-.169h.383v.189a.186.186,0,0,0,.058.156.241.241,0,0,0,.153.045.234.234,0,0,0,.153-.047.229.229,0,0,0,.057-.183v-.16a.264.264,0,0,0-.063-.2.294.294,0,0,0-.2-.058h-.136v-.291h.159a.3.3,0,0,0,.179-.046.194.194,0,0,0,.064-.169Z",
    fill: "#f14941"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2952",
    "data-name": "\\uD328\\uC2A4 2952",
    d: "M935.576,7712.044a.839.839,0,0,0-.9,0,.478.478,0,0,0-.152.379v.11h.382v-.13a.185.185,0,0,1,.058-.155.232.232,0,0,1,.153-.047.219.219,0,0,1,.152.049.224.224,0,0,1,.058.184v.113a.2.2,0,0,1-.064.17.145.145,0,0,1-.042.022h.444a.454.454,0,0,0,.069-.263v-.053A.47.47,0,0,0,935.576,7712.044Z",
    fill: "#f14941"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2953",
    "data-name": "\\uD328\\uC2A4 2953",
    d: "M935.027,7709.659a.358.358,0,0,1-.048.051.377.377,0,0,1-.12.058.747.747,0,0,1-.186.02v.232h.3v1.586h.39v-1.947Z",
    fill: "#f14941"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2954",
    "data-name": "\\uD328\\uC2A4 2954",
    d: "M933.764,7709.659v.429H936.5v-.429Z",
    fill: "#cac8c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2955",
    "data-name": "\\uD328\\uC2A4 2955",
    d: "M935.363,7709.659v.429h-.389v-.068h-.3v-.233a.709.709,0,0,0,.186-.02.382.382,0,0,0,.119-.057.363.363,0,0,0,.049-.051Z",
    fill: "#b9362f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1428",
    "data-name": "\\uADF8\\uB8F9 1428"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2956",
    "data-name": "\\uD328\\uC2A4 2956",
    d: "M919.29,7707.71h-1.026l-.009-4.661h1.039Z",
    fill: "#191917"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_530",
    "data-name": "\\uC0AC\\uAC01\\uD615 530",
    width: 1.022,
    height: 4.661,
    transform: "translate(922.34 7703.049)",
    fill: "#191917"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_531",
    "data-name": "\\uC0AC\\uAC01\\uD615 531",
    width: 0.799,
    height: 4.661,
    transform: "translate(919.861 7703.049)",
    fill: "#191917"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2957",
    "data-name": "\\uD328\\uC2A4 2957",
    d: "M927.723,7707.71h-.784s.012-4.023,0-4.661h.786Z",
    fill: "#191917"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2958",
    "data-name": "\\uD328\\uC2A4 2958",
    d: "M925.393,7707.71h-.766s.012-3.108,0-4.661h.768Z",
    fill: "#191917"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2959",
    "data-name": "\\uD328\\uC2A4 2959",
    d: "M931.453,7707.71h-.562v-4.661h.561S931.447,7706.156,931.453,7707.71Z",
    fill: "#191917"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_532",
    "data-name": "\\uC0AC\\uAC01\\uD615 532",
    width: 0.548,
    height: 4.661,
    transform: "translate(921.24 7703.049)",
    fill: "#191917"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_533",
    "data-name": "\\uC0AC\\uAC01\\uD615 533",
    width: 0.551,
    height: 4.661,
    transform: "translate(928.943 7703.049)",
    fill: "#191917"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2960",
    "data-name": "\\uD328\\uC2A4 2960",
    d: "M930.419,7707.71h-.555c.005-1.554,0-4.661,0-4.661h.554Z",
    fill: "#191917"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_534",
    "data-name": "\\uC0AC\\uAC01\\uD615 534",
    width: 0.338,
    height: 4.661,
    transform: "translate(925.98 7703.049)",
    fill: "#191917"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_535",
    "data-name": "\\uC0AC\\uAC01\\uD615 535",
    width: 0.303,
    height: 4.661,
    transform: "translate(923.838 7703.049)",
    fill: "#191917"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_536",
    "data-name": "\\uC0AC\\uAC01\\uD615 536",
    width: 0.278,
    height: 4.661,
    transform: "translate(928.202 7703.049)",
    fill: "#191917"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1433",
    "data-name": "\\uADF8\\uB8F9 1433"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1430",
    "data-name": "\\uADF8\\uB8F9 1430"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_35",
    "data-name": "\\uD0C0\\uC6D0 35",
    cx: 2.82,
    cy: 2.82,
    r: 2.82,
    transform: "translate(934.178 7720.616)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2961",
    "data-name": "\\uD328\\uC2A4 2961",
    d: "M937,7721.838a1.6,1.6,0,0,0-1.021,2.827l-.287.763a.154.154,0,0,0,.1.185.145.145,0,0,0,.183-.024l.518-.64a1.6,1.6,0,1,0,.51-3.111Z",
    fill: "#f22723"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1429",
    "data-name": "\\uADF8\\uB8F9 1429"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2962",
    "data-name": "\\uD328\\uC2A4 2962",
    d: "M937,7727.155a3.672,3.672,0,0,1-.458-.028l.043-.354a3.5,3.5,0,0,0,.67.016l.026.356C937.186,7727.152,937.093,7727.155,937,7727.155Zm.649-.056-.062-.352a3.425,3.425,0,0,0,.644-.181l.131.332A3.769,3.769,0,0,1,937.647,7727.1Zm-1.472-.035a3.8,3.8,0,0,1-.7-.235l.147-.326a3.342,3.342,0,0,0,.634.213Zm2.522-.319-.163-.318a3.331,3.331,0,0,0,.562-.363l.223.279A3.753,3.753,0,0,1,938.7,7726.745Zm-3.555-.085a3.73,3.73,0,0,1-.6-.432l.236-.268a3.447,3.447,0,0,0,.544.391Zm4.454-.563-.249-.255a3.378,3.378,0,0,0,.43-.513l.3.2A3.7,3.7,0,0,1,939.6,7726.1Zm-5.321-.127a3.773,3.773,0,0,1-.448-.589l.3-.187a3.334,3.334,0,0,0,.406.532Zm5.99-.756-.313-.171a3.359,3.359,0,0,0,.26-.617l.341.106A3.735,3.735,0,0,1,940.265,7725.214Zm-6.616-.158a3.662,3.662,0,0,1-.254-.7l.345-.089a3.4,3.4,0,0,0,.23.628Zm6.995-.884-.35-.07a3.373,3.373,0,0,0,.066-.666l.357-.015v.015A3.692,3.692,0,0,1,940.644,7724.172Zm-7.323-.175a3.761,3.761,0,0,1-.042-.561c0-.06,0-.119,0-.178l.356.017c0,.054,0,.107,0,.161a3.311,3.311,0,0,0,.038.508Zm7.021-.91a3.326,3.326,0,0,0-.134-.655l.341-.106a3.718,3.718,0,0,1,.148.725Zm-6.67-.145-.353-.052a3.62,3.62,0,0,1,.18-.719l.336.122A3.265,3.265,0,0,0,933.672,7722.942Zm6.42-.824a3.293,3.293,0,0,0-.323-.586l.294-.2a3.632,3.632,0,0,1,.357.649Zm-6.128-.134-.322-.154a3.726,3.726,0,0,1,.386-.633l.285.215A3.415,3.415,0,0,0,933.964,7721.984Zm5.6-.718a3.327,3.327,0,0,0-.481-.466l.222-.28a3.745,3.745,0,0,1,.532.515Zm-5.039-.111-.262-.242a3.685,3.685,0,0,1,.554-.491l.209.289A3.425,3.425,0,0,0,934.527,7721.155Zm4.285-.55a3.343,3.343,0,0,0-.6-.3l.129-.333a3.8,3.8,0,0,1,.66.336Zm-3.5-.077-.18-.309a3.723,3.723,0,0,1,.674-.306l.115.338A3.408,3.408,0,0,0,935.309,7720.528Zm2.589-.332a3.37,3.37,0,0,0-.659-.114l.025-.356a3.671,3.671,0,0,1,.729.126Zm-1.658-.037-.08-.348a3.764,3.764,0,0,1,.734-.093l.01.357A3.32,3.32,0,0,0,936.24,7720.159Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1432",
    "data-name": "\\uADF8\\uB8F9 1432"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2963",
    "data-name": "\\uD328\\uC2A4 2963",
    d: "M913.771,7723.8a1.106,1.106,0,0,0,0-.719,1.236,1.236,0,1,0-.22-.38,1.123,1.123,0,0,0-.623-.36,8.3,8.3,0,0,0-.219-2.451,8.347,8.347,0,0,0-.219,2.451,1.13,1.13,0,0,0-.623.36,1.236,1.236,0,1,0-.219.38,1.106,1.106,0,0,0,0,.719,1.236,1.236,0,1,0,.219.38,1.116,1.116,0,0,0,.623.36,8.358,8.358,0,0,0,.219,2.452,8.313,8.313,0,0,0,.219-2.452,1.11,1.11,0,0,0,.623-.36,1.236,1.236,0,1,0,.22-.38Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1431",
    "data-name": "\\uADF8\\uB8F9 1431"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2964",
    "data-name": "\\uD328\\uC2A4 2964",
    d: "M912.709,7727.155a3.719,3.719,0,1,1,3.719-3.718A3.722,3.722,0,0,1,912.709,7727.155Zm0-7.279a3.561,3.561,0,1,0,3.561,3.561A3.564,3.564,0,0,0,912.709,7719.876Z"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_537",
    "data-name": "\\uC0AC\\uAC01\\uD615 537",
    width: 12.243,
    height: 1.918,
    transform: "translate(918.733 7730.798)",
    fill: "#e8ebdd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_538",
    "data-name": "\\uC0AC\\uAC01\\uD615 538",
    width: 11.063,
    height: 1.918,
    transform: "translate(919.323 7733.509)",
    fill: "#e8ebdd"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1439",
    "data-name": "\\uADF8\\uB8F9 1439",
    transform: "translate(0 -6914)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1436",
    "data-name": "\\uADF8\\uB8F9 1436"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uC0AC\\uAC01\\uD615_539",
    "data-name": "\\uC0AC\\uAC01\\uD615 539",
    d: "M3.153,0H74.118a3.155,3.155,0,0,1,3.155,3.155V117.214a3.153,3.153,0,0,1-3.153,3.153H3.153A3.153,3.153,0,0,1,0,117.214V3.153A3.153,3.153,0,0,1,3.153,0Z",
    transform: "translate(456.441 7610.128)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2965",
    "data-name": "\\uD328\\uC2A4 2965",
    d: "M533.714,7613.282V7727.34a3.153,3.153,0,0,1-3.153,3.155h-.466V7610.129h.466A3.153,3.153,0,0,1,533.714,7613.282Z",
    fill: "#e3ecfb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2966",
    "data-name": "\\uD328\\uC2A4 2966",
    d: "M460.059,7610.129V7730.5h-.465a3.153,3.153,0,0,1-3.153-3.155V7613.282a3.152,3.152,0,0,1,3.153-3.153Z",
    fill: "#e3ecfb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1438",
    "data-name": "\\uADF8\\uB8F9 1438"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_540",
    "data-name": "\\uC0AC\\uAC01\\uD615 540",
    width: 16.252,
    height: 28.455,
    transform: "translate(509.305 7634.186) rotate(90)",
    fill: "#d5ddeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_541",
    "data-name": "\\uC0AC\\uAC01\\uD615 541",
    width: 24.404,
    height: 12.202,
    transform: "translate(482.875 7636.211)",
    fill: "#373f70"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1437",
    "data-name": "\\uADF8\\uB8F9 1437"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2967",
    "data-name": "\\uD328\\uC2A4 2967",
    d: "M488.193,7646.935c-1.633,0-1.4-2.326-1.4-2.326.594.838,1.027.789,1.027.789a2.1,2.1,0,0,1,.042-2.429,1.54,1.54,0,0,0,1.033,1.375c-.845-1.146.573-2.678.573-2.678s-.487,1.031.817,1.9a1.62,1.62,0,0,1,.916,1.4,1.435,1.435,0,0,1-.759,1.218.907.907,0,0,0,.941-.759.985.985,0,0,1-.136,1.212,1.057,1.057,0,0,1-.773.272Z",
    fill: "#f76f65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2968",
    "data-name": "\\uD328\\uC2A4 2968",
    d: "M494.113,7646.935c-1.632,0-1.4-2.326-1.4-2.326.594.838,1.027.789,1.027.789a2.1,2.1,0,0,1,.042-2.429,1.541,1.541,0,0,0,1.034,1.375c-.846-1.146.572-2.678.572-2.678s-.487,1.031.817,1.9a1.622,1.622,0,0,1,.917,1.4,1.437,1.437,0,0,1-.76,1.218.907.907,0,0,0,.941-.759.984.984,0,0,1-.136,1.212,1.057,1.057,0,0,1-.773.272Z",
    fill: "#f76f65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2969",
    "data-name": "\\uD328\\uC2A4 2969",
    d: "M500.034,7646.935c-1.633,0-1.4-2.326-1.4-2.326.594.838,1.027.789,1.027.789a2.1,2.1,0,0,1,.042-2.429,1.541,1.541,0,0,0,1.034,1.375c-.845-1.146.573-2.678.573-2.678s-.487,1.031.816,1.9a1.622,1.622,0,0,1,.917,1.4,1.437,1.437,0,0,1-.759,1.218.906.906,0,0,0,.94-.759.984.984,0,0,1-.136,1.212,1.057,1.057,0,0,1-.773.272Z",
    fill: "#f76f65"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1444",
    "data-name": "\\uADF8\\uB8F9 1444",
    transform: "translate(0 -6914)"
  }, _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1441",
    "data-name": "\\uADF8\\uB8F9 1441"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_542",
    "data-name": "\\uC0AC\\uAC01\\uD615 542",
    width: 226.889,
    height: 4.669,
    transform: "translate(308.552 7729.588)",
    fill: "#34471b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_543",
    "data-name": "\\uC0AC\\uAC01\\uD615 543",
    width: 226.889,
    height: 9.338,
    transform: "translate(308.552 7734.257)",
    fill: "#8a6b4f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_544",
    "data-name": "\\uC0AC\\uAC01\\uD615 544",
    width: 226.889,
    height: 98.04,
    transform: "translate(308.552 7790.284)",
    fill: "#c7ae9a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_545",
    "data-name": "\\uC0AC\\uAC01\\uD615 545",
    width: 226.889,
    height: 46.689,
    transform: "translate(308.552 7743.595)",
    fill: "#a68a79"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1440",
    "data-name": "\\uADF8\\uB8F9 1440"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2970",
    "data-name": "\\uD328\\uC2A4 2970",
    d: "M343.775,7760.6a2.02,2.02,0,1,0-2.019,2.02A2.019,2.019,0,0,0,343.775,7760.6Z",
    fill: "#7d5441"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2971",
    "data-name": "\\uD328\\uC2A4 2971",
    d: "M396.932,7778.485a2.15,2.15,0,1,0-2.149,2.149A2.15,2.15,0,0,0,396.932,7778.485Z",
    fill: "#7d5441"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2972",
    "data-name": "\\uD328\\uC2A4 2972",
    d: "M463.124,7760.948a1.819,1.819,0,1,0-1.819,1.819A1.819,1.819,0,0,0,463.124,7760.948Z",
    fill: "#7d5441"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_36",
    "data-name": "\\uD0C0\\uC6D0 36",
    cx: 1.798,
    cy: 1.798,
    r: 1.798,
    transform: "translate(359.979 7839.913)",
    fill: "#7d5441"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2973",
    "data-name": "\\uD328\\uC2A4 2973",
    d: "M330.418,7819.274a1.716,1.716,0,1,0-1.715,1.715A1.715,1.715,0,0,0,330.418,7819.274Z",
    fill: "#7d5441"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2974",
    "data-name": "\\uD328\\uC2A4 2974",
    d: "M423.151,7850.724a2.079,2.079,0,1,0-2.079,2.08A2.079,2.079,0,0,0,423.151,7850.724Z",
    fill: "#7d5441"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_37",
    "data-name": "\\uD0C0\\uC6D0 37",
    cx: 2.042,
    cy: 2.042,
    r: 2.042,
    transform: "translate(447.006 7814.612)",
    fill: "#7d5441"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2975",
    "data-name": "\\uD328\\uC2A4 2975",
    d: "M507.715,7850.724a1.943,1.943,0,1,0-1.944,1.944A1.943,1.943,0,0,0,507.715,7850.724Z",
    fill: "#7d5441"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_38",
    "data-name": "\\uD0C0\\uC6D0 38",
    cx: 2.041,
    cy: 2.041,
    r: 2.041,
    transform: "translate(521.106 7780.306)",
    fill: "#7d5441"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2976",
    "data-name": "\\uD328\\uC2A4 2976",
    d: "M510.951,7850.718a1.348,1.348,0,1,0-1.348,1.348A1.347,1.347,0,0,0,510.951,7850.718Z",
    fill: "#7d5441"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2977",
    "data-name": "\\uD328\\uC2A4 2977",
    d: "M520.857,7760.1a1.832,1.832,0,1,0-1.832,1.831A1.832,1.832,0,0,0,520.857,7760.1Z",
    fill: "#7d5441"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1443",
    "data-name": "\\uADF8\\uB8F9 1443"
  }, _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_546",
    "data-name": "\\uC0AC\\uAC01\\uD615 546",
    width: 6.565,
    height: 35.81,
    transform: "translate(338.602 7694.111)",
    fill: "#5c3828"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_547",
    "data-name": "\\uC0AC\\uAC01\\uD615 547",
    width: 3.283,
    height: 35.81,
    transform: "translate(341.885 7694.111)",
    opacity: 0.15,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1442",
    "data-name": "\\uADF8\\uB8F9 1442"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2978",
    "data-name": "\\uD328\\uC2A4 2978",
    d: "M341.885,7614.81v90.044c19.283,0,34.915-14.261,34.915-43.268C376.8,7629.993,355.218,7614.81,341.885,7614.81Z",
    fill: "#96bd6c"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2979",
    "data-name": "\\uD328\\uC2A4 2979",
    d: "M341.885,7614.81v90.044c19.283,0,34.915-14.261,34.915-43.268C376.8,7629.993,355.218,7614.81,341.885,7614.81Z",
    opacity: 0.15,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2980",
    "data-name": "\\uD328\\uC2A4 2980",
    d: "M341.885,7614.81v90.044c-19.283,0-34.915-14.261-34.915-43.268C306.97,7629.993,328.552,7614.81,341.885,7614.81Z",
    fill: "#96bd6c"
  }))))), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    id: "\\uC9C0\\uC911\\uC5F4_\\uAD50\\uD658\\uAE30",
    "data-name": "\\uC9C0\\uC911\\uC5F4 \\uAD50\\uD658\\uAE30",
    transform: "translate(365.169 958.985)",
    fill: "#fff",
    fontSize: 17,
    fontFamily: "NanumGothicExtraBold, NanumGothic"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\uC9C0\uC911\uC5F4 \uAD50\uD658\uAE30"))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1445",
    "data-name": "\\uADF8\\uB8F9 1445",
    transform: "translate(0 -6914)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2981",
    "data-name": "\\uD328\\uC2A4 2981",
    d: "M338.873,7806.639a19.277,19.277,0,0,1,4.982-12.742,19.491,19.491,0,0,1,10.024-6.114c.364-.092.53-.223.495-.634-.047-.536,0-1.079-.015-1.618a1.27,1.27,0,0,1,.636-1.279,1.343,1.343,0,0,1,1.467.15q3.5,2.268,7.007,4.524c1.075.694,2.154,1.383,3.225,2.086a1.251,1.251,0,0,1-.019,2.3q-5.1,3.289-10.195,6.573a1.323,1.323,0,0,1-1.46.175,1.291,1.291,0,0,1-.661-1.314c.017-.539-.019-1.081.011-1.619.021-.369-.116-.466-.461-.431a17.373,17.373,0,0,0-5.266,1.3,12.244,12.244,0,0,0-7.608,9.842,17.575,17.575,0,0,0-.108,3.331c.013.444-.1.772-.587.843s-.707-.216-.82-.633A18.047,18.047,0,0,1,338.873,7806.639Z",
    fill: "#ff4b27"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1446",
    "data-name": "\\uADF8\\uB8F9 1446",
    transform: "translate(0 -6914)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2982",
    "data-name": "\\uD328\\uC2A4 2982",
    d: "M341.873,7836.639a19.277,19.277,0,0,1,4.982-12.742,19.491,19.491,0,0,1,10.024-6.114c.364-.092.53-.223.495-.634-.047-.536,0-1.079-.015-1.618a1.27,1.27,0,0,1,.636-1.279,1.343,1.343,0,0,1,1.467.15q3.5,2.268,7.007,4.524c1.075.694,2.154,1.383,3.225,2.086a1.251,1.251,0,0,1-.019,2.3q-5.1,3.289-10.195,6.573a1.323,1.323,0,0,1-1.46.175,1.291,1.291,0,0,1-.661-1.314c.017-.539-.019-1.081.011-1.619.021-.369-.116-.466-.461-.431a17.373,17.373,0,0,0-5.266,1.3,12.244,12.244,0,0,0-7.608,9.842,17.575,17.575,0,0,0-.108,3.331c.013.444-.1.772-.587.843s-.707-.216-.82-.633A18.047,18.047,0,0,1,341.873,7836.639Z",
    fill: "#ff4b27"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1447",
    "data-name": "\\uADF8\\uB8F9 1447",
    transform: "translate(0 -6914)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2983",
    "data-name": "\\uD328\\uC2A4 2983",
    d: "M468.441,7806.639a19.278,19.278,0,0,0-4.983-12.742,19.487,19.487,0,0,0-10.024-6.114c-.364-.092-.53-.223-.494-.634.046-.536,0-1.079.015-1.618a1.27,1.27,0,0,0-.637-1.279,1.343,1.343,0,0,0-1.467.15q-3.5,2.268-7.006,4.524c-1.076.694-2.155,1.383-3.226,2.086a1.251,1.251,0,0,0,.019,2.3q5.1,3.289,10.2,6.573a1.325,1.325,0,0,0,1.461.175,1.294,1.294,0,0,0,.661-1.314c-.017-.539.018-1.081-.012-1.619-.02-.369.116-.466.461-.431a17.366,17.366,0,0,1,5.266,1.3,12.244,12.244,0,0,1,7.608,9.842,17.576,17.576,0,0,1,.109,3.331c-.013.444.1.772.586.843s.708-.216.82-.633A18.09,18.09,0,0,0,468.441,7806.639Z",
    fill: "#ff4b27"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1448",
    "data-name": "\\uADF8\\uB8F9 1448",
    transform: "translate(0 -6914)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2984",
    "data-name": "\\uD328\\uC2A4 2984",
    d: "M465.441,7836.639a19.278,19.278,0,0,0-4.983-12.742,19.487,19.487,0,0,0-10.024-6.114c-.364-.092-.53-.223-.494-.634.046-.536,0-1.079.015-1.618a1.27,1.27,0,0,0-.637-1.279,1.343,1.343,0,0,0-1.467.15q-3.5,2.268-7.006,4.524c-1.076.694-2.155,1.383-3.226,2.086a1.251,1.251,0,0,0,.019,2.3q5.1,3.289,10.2,6.573a1.325,1.325,0,0,0,1.461.175,1.294,1.294,0,0,0,.661-1.314c-.017-.539.018-1.081-.012-1.619-.02-.369.116-.466.461-.431a17.366,17.366,0,0,1,5.266,1.3,12.244,12.244,0,0,1,7.608,9.842,17.576,17.576,0,0,1,.109,3.331c-.013.444.1.772.586.843s.708-.216.82-.633A18.09,18.09,0,0,0,465.441,7836.639Z",
    fill: "#ff4b27"
  }))), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_548",
    "data-name": "\\uC0AC\\uAC01\\uD615 548",
    width: 11,
    height: 63,
    transform: "translate(447.44 759.81) rotate(90)",
    fill: "url(#linear-gradient-14)"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_549",
    "data-name": "\\uC0AC\\uAC01\\uD615 549",
    width: 11,
    height: 97,
    transform: "translate(395.44 856.811) rotate(180)",
    fill: "url(#linear-gradient-15)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2985",
    "data-name": "\\uD328\\uC2A4 2985",
    d: "M415.441,7801.81v32h-20v-60h-11v71h42v-43Z",
    transform: "translate(0 -6914)",
    fill: "url(#linear-gradient-16)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2986",
    "data-name": "\\uD328\\uC2A4 2986",
    d: "M503.441,7673.81h-56v11h56v25h-88v92h11v-81h88v-47Z",
    transform: "translate(0 -6914)",
    fill: "url(#linear-gradient-17)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2987",
    "data-name": "\\uD328\\uC2A4 2987",
    d: "M722.267,7615.81l-9.152-14.5-9.391,14.5Z",
    transform: "translate(0 -6914)",
    fill: "#999"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2988",
    "data-name": "\\uD328\\uC2A4 2988",
    d: "M932.441,7676.407l14.5-9.151-14.5-9.392Z",
    transform: "translate(0 -6914)",
    fill: "#999"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2989",
    "data-name": "\\uD328\\uC2A4 2989",
    d: "M983.441,7710.983l-14.5,9.152,14.5,9.392Z",
    transform: "translate(0 -6914)",
    fill: "#999"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2990",
    "data-name": "\\uD328\\uC2A4 2990",
    d: "M639.441,7710.983l-14.5,9.152,14.5,9.392Z",
    transform: "translate(0 -6914)",
    fill: "#999"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2991",
    "data-name": "\\uD328\\uC2A4 2991",
    d: "M411.669,7797.81l9.152,14.5,9.391-14.5Z",
    transform: "translate(0 -6914)",
    fill: "#f44522"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2992",
    "data-name": "\\uD328\\uC2A4 2992",
    d: "M399.037,7777.81l-9.152-14.5-9.391,14.5Z",
    transform: "translate(0 -6914)",
    fill: "#999"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2993",
    "data-name": "\\uD328\\uC2A4 2993",
    d: "M629.441,7676.407l14.5-9.151-14.5-9.392Z",
    transform: "translate(0 -6914)",
    fill: "#999"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2994",
    "data-name": "\\uD328\\uC2A4 2994",
    d: "M443.441,7688.407l14.5-9.151-14.5-9.392Z",
    transform: "translate(0 -6914)",
    fill: "#f44522"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2995",
    "data-name": "\\uD328\\uC2A4 2995",
    d: "M764.844,7605.81l9.152,14.5,9.391-14.5Z",
    transform: "translate(0 -6914)",
    fill: "#999"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1449",
    "data-name": "\\uADF8\\uB8F9 1449",
    transform: "translate(0 -6914)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_550",
    "data-name": "\\uC0AC\\uAC01\\uD615 550",
    width: 34,
    height: 16,
    transform: "translate(375.441 7671.81)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_551",
    "data-name": "\\uC0AC\\uAC01\\uD615 551",
    width: 26,
    height: 10,
    rx: 2.529,
    transform: "translate(379.441 7674.81)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("text", {
    id: "T1",
    transform: "translate(387.493 7683.508)",
    fontSize: 9,
    fontFamily: "NanumGothicBold, NanumGothic"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "T1")))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2996",
    "data-name": "\\uD328\\uC2A4 2996",
    d: "M713.441,7632.77v1.138c0,2.2-.139,4.4-.276,6.594-.158,2.546.539,7.09,7.177,8.32,9.37,1.737,24.713,4.737,23.041-2.263s-31.714-1.1-29.942,8.7,27.13,11,27.95,5.9-27.31-2.7-28.245,7.1,29.407,12.468,30.237,6.635-29.714-5.77-29.942,7.7,30.366,9.945,30.068,5.207-27.73-7.035-29.513,7.113,33.557,10.148,29.387,4.648-30.6-1.946-29.387,8.277c1.135,9.544,37.345,26.786,56.61,4.193a16.316,16.316,0,0,0,3.835-10.6V7632.77",
    transform: "translate(0 -6914)",
    fill: "none",
    stroke: "#666",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2997",
    "data-name": "\\uD328\\uC2A4 2997",
    d: "M446.441,7709.81h-31v88h11v-77h20Z",
    transform: "translate(0 -6914)",
    fill: "url(#linear-gradient-18)"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1450",
    "data-name": "\\uADF8\\uB8F9 1450",
    transform: "translate(0 -6914)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_552",
    "data-name": "\\uC0AC\\uAC01\\uD615 552",
    width: 34,
    height: 16,
    transform: "translate(431.441 7706.81)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_553",
    "data-name": "\\uC0AC\\uAC01\\uD615 553",
    width: 26,
    height: 10,
    rx: 2.529,
    transform: "translate(435.441 7709.81)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("text", {
    id: "T2",
    transform: "translate(443.493 7718.508)",
    fontSize: 9,
    fontFamily: "NanumGothicBold, NanumGothic"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "T2")))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1463",
    "data-name": "\\uADF8\\uB8F9 1463",
    transform: "translate(0 -6914)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2998",
    "data-name": "\\uD328\\uC2A4 2998",
    d: "M1011.489,7671.269v-4.7h0a.838.838,0,0,0,.838-.838v-7.789a.838.838,0,0,0-.838-.838h-1.865v83.848h1.865a.838.838,0,0,0,.838-.837v-7.79a.838.838,0,0,0-.838-.837h0v-4.7a1.647,1.647,0,0,0-.405-1.082h0a1.643,1.643,0,0,1-.406-1.082v-51.186a1.644,1.644,0,0,1,.406-1.082h0A1.649,1.649,0,0,0,1011.489,7671.269Z",
    fill: "#596878"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2999",
    "data-name": "\\uD328\\uC2A4 2999",
    d: "M1017.647,7671.269v-4.7h0a.838.838,0,0,0,.837-.838v-7.789a.838.838,0,0,0-.837-.838h-1.866v83.848h1.866a.837.837,0,0,0,.837-.837v-7.79a.837.837,0,0,0-.837-.837h0v-4.7a1.648,1.648,0,0,0-.406-1.082h0a1.643,1.643,0,0,1-.406-1.082v-51.186a1.644,1.644,0,0,1,.406-1.082h0A1.65,1.65,0,0,0,1017.647,7671.269Z",
    fill: "#596878"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3000",
    "data-name": "\\uD328\\uC2A4 3000",
    d: "M1023.8,7671.269v-4.7h0a.838.838,0,0,0,.837-.838v-7.789a.838.838,0,0,0-.837-.838h-1.866v83.848h1.866a.837.837,0,0,0,.837-.837v-7.79a.837.837,0,0,0-.837-.837h0v-4.7a1.643,1.643,0,0,0-.406-1.082h0a1.643,1.643,0,0,1-.406-1.082v-51.186a1.644,1.644,0,0,1,.406-1.082h0A1.645,1.645,0,0,0,1023.8,7671.269Z",
    fill: "#596878"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3001",
    "data-name": "\\uD328\\uC2A4 3001",
    d: "M1029.961,7671.269v-4.7h0a.838.838,0,0,0,.838-.838v-7.789a.838.838,0,0,0-.838-.838H1028.1v83.848h1.865a.838.838,0,0,0,.838-.837v-7.79a.838.838,0,0,0-.838-.837h0v-4.7a1.643,1.643,0,0,0-.406-1.082h0a1.642,1.642,0,0,1-.406-1.082v-51.186a1.643,1.643,0,0,1,.406-1.082h0A1.645,1.645,0,0,0,1029.961,7671.269Z",
    fill: "#596878"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3002",
    "data-name": "\\uD328\\uC2A4 3002",
    d: "M1036.118,7671.269v-4.7h0a.838.838,0,0,0,.838-.838v-7.789a.838.838,0,0,0-.838-.838h-1.865v83.848h1.865a.838.838,0,0,0,.838-.837v-7.79a.838.838,0,0,0-.838-.837h0v-4.7a1.643,1.643,0,0,0-.406-1.082h0a1.642,1.642,0,0,1-.406-1.082v-51.186a1.643,1.643,0,0,1,.406-1.082h0A1.645,1.645,0,0,0,1036.118,7671.269Z",
    fill: "#596878"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3003",
    "data-name": "\\uD328\\uC2A4 3003",
    d: "M1042.275,7671.269v-4.7h0a.838.838,0,0,0,.838-.838v-7.789a.838.838,0,0,0-.838-.838h-1.865v83.848h1.865a.838.838,0,0,0,.838-.837v-7.79a.838.838,0,0,0-.838-.837h0v-4.7a1.643,1.643,0,0,0-.406-1.082h0a1.648,1.648,0,0,1-.406-1.082v-51.186a1.649,1.649,0,0,1,.406-1.082h0A1.645,1.645,0,0,0,1042.275,7671.269Z",
    fill: "#596878"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3004",
    "data-name": "\\uD328\\uC2A4 3004",
    d: "M1048.432,7671.269v-4.7h0a.838.838,0,0,0,.838-.838v-7.789a.838.838,0,0,0-.838-.838h-1.865v83.848h1.865a.838.838,0,0,0,.838-.837v-7.79a.838.838,0,0,0-.838-.837h0v-4.7a1.643,1.643,0,0,0-.406-1.082h0a1.647,1.647,0,0,1-.405-1.082v-51.186a1.648,1.648,0,0,1,.405-1.082h0A1.645,1.645,0,0,0,1048.432,7671.269Z",
    fill: "#596878"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3005",
    "data-name": "\\uD328\\uC2A4 3005",
    d: "M1054.59,7671.269v-4.7h0a.838.838,0,0,0,.837-.838v-7.789a.838.838,0,0,0-.837-.838h-1.866v83.848h1.866a.837.837,0,0,0,.837-.837v-7.79a.837.837,0,0,0-.837-.837h0v-4.7a1.644,1.644,0,0,0-.407-1.082h0a1.647,1.647,0,0,1-.405-1.082v-51.186a1.648,1.648,0,0,1,.405-1.082h0A1.646,1.646,0,0,0,1054.59,7671.269Z",
    fill: "#596878"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1452",
    "data-name": "\\uADF8\\uB8F9 1452"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3006",
    "data-name": "\\uD328\\uC2A4 3006",
    d: "M1072.721,7670.594h-2.257v8.965h2.257a.775.775,0,0,0,.774-.774v-7.417A.774.774,0,0,0,1072.721,7670.594Z",
    fill: "#596878"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1451",
    "data-name": "\\uADF8\\uB8F9 1451"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3007",
    "data-name": "\\uD328\\uC2A4 3007",
    d: "M1072.721,7677.377h-2.257v2.182h2.257a.775.775,0,0,0,.774-.774v-1.893C1073.495,7677.16,1073.148,7677.377,1072.721,7677.377Z",
    fill: "#000c1c",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3008",
    "data-name": "\\uD328\\uC2A4 3008",
    d: "M1072.721,7670.594h-2.257v1.16h2.257c.427,0,.774.218.774.486v-.872A.774.774,0,0,0,1072.721,7670.594Z",
    fill: "#fff",
    opacity: 0.3
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1453",
    "data-name": "\\uADF8\\uB8F9 1453"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_554",
    "data-name": "\\uC0AC\\uAC01\\uD615 554",
    width: 3.454,
    height: 94.645,
    rx: 0.76,
    transform: "translate(1006.17 7647.81)",
    fill: "#d1d9e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3009",
    "data-name": "\\uD328\\uC2A4 3009",
    d: "M1008.864,7739.589h-1.934a.738.738,0,0,1-.76-.714v2.821a.76.76,0,0,0,.76.76h1.934a.76.76,0,0,0,.76-.76v-2.821A.738.738,0,0,1,1008.864,7739.589Z",
    fill: "#000c1c",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3010",
    "data-name": "\\uD328\\uC2A4 3010",
    d: "M1008.864,7647.81h-1.934a.76.76,0,0,0-.76.76v2.821a.738.738,0,0,1,.76-.714h1.934a.738.738,0,0,1,.76.714v-2.821A.76.76,0,0,0,1008.864,7647.81Z",
    fill: "#fff",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1454",
    "data-name": "\\uADF8\\uB8F9 1454"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_555",
    "data-name": "\\uC0AC\\uAC01\\uD615 555",
    width: 3.454,
    height: 94.645,
    rx: 0.76,
    transform: "translate(1012.327 7647.81)",
    fill: "#d1d9e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3011",
    "data-name": "\\uD328\\uC2A4 3011",
    d: "M1015.021,7739.589h-1.934a.738.738,0,0,1-.76-.714v2.821a.76.76,0,0,0,.76.76h1.934a.76.76,0,0,0,.76-.76v-2.821A.738.738,0,0,1,1015.021,7739.589Z",
    fill: "#000c1c",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3012",
    "data-name": "\\uD328\\uC2A4 3012",
    d: "M1015.021,7647.81h-1.934a.759.759,0,0,0-.76.76v2.821a.738.738,0,0,1,.76-.714h1.934a.738.738,0,0,1,.76.714v-2.821A.76.76,0,0,0,1015.021,7647.81Z",
    fill: "#fff",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1455",
    "data-name": "\\uADF8\\uB8F9 1455"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_556",
    "data-name": "\\uC0AC\\uAC01\\uD615 556",
    width: 3.454,
    height: 94.645,
    rx: 0.76,
    transform: "translate(1018.484 7647.81)",
    fill: "#d1d9e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3013",
    "data-name": "\\uD328\\uC2A4 3013",
    d: "M1021.178,7739.589h-1.934a.738.738,0,0,1-.76-.714v2.821a.76.76,0,0,0,.76.76h1.934a.76.76,0,0,0,.76-.76v-2.821A.738.738,0,0,1,1021.178,7739.589Z",
    fill: "#000c1c",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3014",
    "data-name": "\\uD328\\uC2A4 3014",
    d: "M1021.178,7647.81h-1.934a.759.759,0,0,0-.76.76v2.821a.738.738,0,0,1,.76-.714h1.934a.738.738,0,0,1,.76.714v-2.821A.759.759,0,0,0,1021.178,7647.81Z",
    fill: "#fff",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1456",
    "data-name": "\\uADF8\\uB8F9 1456"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_557",
    "data-name": "\\uC0AC\\uAC01\\uD615 557",
    width: 3.454,
    height: 94.645,
    rx: 0.76,
    transform: "translate(1024.641 7647.81)",
    fill: "#d1d9e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3015",
    "data-name": "\\uD328\\uC2A4 3015",
    d: "M1027.336,7739.589H1025.4a.739.739,0,0,1-.76-.714v2.821a.761.761,0,0,0,.76.76h1.935a.761.761,0,0,0,.76-.76v-2.821A.739.739,0,0,1,1027.336,7739.589Z",
    fill: "#000c1c",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3016",
    "data-name": "\\uD328\\uC2A4 3016",
    d: "M1027.336,7647.81H1025.4a.76.76,0,0,0-.76.76v2.821a.739.739,0,0,1,.76-.714h1.935a.739.739,0,0,1,.76.714v-2.821A.76.76,0,0,0,1027.336,7647.81Z",
    fill: "#fff",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1457",
    "data-name": "\\uADF8\\uB8F9 1457"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_558",
    "data-name": "\\uC0AC\\uAC01\\uD615 558",
    width: 3.454,
    height: 94.645,
    rx: 0.76,
    transform: "translate(1030.799 7647.81)",
    fill: "#d1d9e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3017",
    "data-name": "\\uD328\\uC2A4 3017",
    d: "M1033.493,7739.589h-1.934a.738.738,0,0,1-.76-.714v2.821a.76.76,0,0,0,.76.76h1.934a.76.76,0,0,0,.76-.76v-2.821A.738.738,0,0,1,1033.493,7739.589Z",
    fill: "#000c1c",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3018",
    "data-name": "\\uD328\\uC2A4 3018",
    d: "M1033.493,7647.81h-1.934a.76.76,0,0,0-.76.76v2.821a.738.738,0,0,1,.76-.714h1.934a.738.738,0,0,1,.76.714v-2.821A.76.76,0,0,0,1033.493,7647.81Z",
    fill: "#fff",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1458",
    "data-name": "\\uADF8\\uB8F9 1458"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_559",
    "data-name": "\\uC0AC\\uAC01\\uD615 559",
    width: 3.454,
    height: 94.645,
    rx: 0.76,
    transform: "translate(1036.956 7647.81)",
    fill: "#d1d9e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3019",
    "data-name": "\\uD328\\uC2A4 3019",
    d: "M1039.65,7739.589h-1.934a.738.738,0,0,1-.76-.714v2.821a.76.76,0,0,0,.76.76h1.934a.76.76,0,0,0,.76-.76v-2.821A.738.738,0,0,1,1039.65,7739.589Z",
    fill: "#000c1c",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3020",
    "data-name": "\\uD328\\uC2A4 3020",
    d: "M1039.65,7647.81h-1.934a.759.759,0,0,0-.76.76v2.821a.738.738,0,0,1,.76-.714h1.934a.738.738,0,0,1,.76.714v-2.821A.76.76,0,0,0,1039.65,7647.81Z",
    fill: "#fff",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1459",
    "data-name": "\\uADF8\\uB8F9 1459"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_560",
    "data-name": "\\uC0AC\\uAC01\\uD615 560",
    width: 3.454,
    height: 94.645,
    rx: 0.76,
    transform: "translate(1043.113 7647.81)",
    fill: "#d1d9e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3021",
    "data-name": "\\uD328\\uC2A4 3021",
    d: "M1045.807,7739.589h-1.934a.738.738,0,0,1-.76-.714v2.821a.76.76,0,0,0,.76.76h1.934a.76.76,0,0,0,.76-.76v-2.821A.738.738,0,0,1,1045.807,7739.589Z",
    fill: "#000c1c",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3022",
    "data-name": "\\uD328\\uC2A4 3022",
    d: "M1045.807,7647.81h-1.934a.759.759,0,0,0-.76.76v2.821a.738.738,0,0,1,.76-.714h1.934a.738.738,0,0,1,.76.714v-2.821A.759.759,0,0,0,1045.807,7647.81Z",
    fill: "#fff",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1460",
    "data-name": "\\uADF8\\uB8F9 1460"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_561",
    "data-name": "\\uC0AC\\uAC01\\uD615 561",
    width: 3.454,
    height: 94.645,
    rx: 0.76,
    transform: "translate(1049.27 7647.81)",
    fill: "#d1d9e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3023",
    "data-name": "\\uD328\\uC2A4 3023",
    d: "M1051.964,7739.589h-1.934a.738.738,0,0,1-.76-.714v2.821a.76.76,0,0,0,.76.76h1.934a.76.76,0,0,0,.76-.76v-2.821A.738.738,0,0,1,1051.964,7739.589Z",
    fill: "#000c1c",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3024",
    "data-name": "\\uD328\\uC2A4 3024",
    d: "M1051.964,7647.81h-1.934a.759.759,0,0,0-.76.76v2.821a.738.738,0,0,1,.76-.714h1.934a.738.738,0,0,1,.76.714v-2.821A.759.759,0,0,0,1051.964,7647.81Z",
    fill: "#fff",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1461",
    "data-name": "\\uADF8\\uB8F9 1461"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_562",
    "data-name": "\\uC0AC\\uAC01\\uD615 562",
    width: 3.454,
    height: 94.645,
    rx: 0.76,
    transform: "translate(1055.427 7647.81)",
    fill: "#d1d9e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3025",
    "data-name": "\\uD328\\uC2A4 3025",
    d: "M1058.121,7739.589h-1.934a.738.738,0,0,1-.76-.714v2.821a.76.76,0,0,0,.76.76h1.934a.76.76,0,0,0,.76-.76v-2.821A.738.738,0,0,1,1058.121,7739.589Z",
    fill: "#000c1c",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3026",
    "data-name": "\\uD328\\uC2A4 3026",
    d: "M1058.121,7647.81h-1.934a.759.759,0,0,0-.76.76v2.821a.738.738,0,0,1,.76-.714h1.934a.738.738,0,0,1,.76.714v-2.821A.759.759,0,0,0,1058.121,7647.81Z",
    fill: "#fff",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3027",
    "data-name": "\\uD328\\uC2A4 3027",
    d: "M1065.341,7647.81h-5.08a.759.759,0,0,0-.76.76V7741.7a.76.76,0,0,0,.76.76h7.325a3.247,3.247,0,0,0,3.247-3.247V7653.3A5.492,5.492,0,0,0,1065.341,7647.81Z",
    fill: "#d1d9e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3028",
    "data-name": "\\uD328\\uC2A4 3028",
    d: "M1068.055,7739.553a3.117,3.117,0,0,0,2.778-3.015v-80.7a5.141,5.141,0,0,0-3.079-4.635,7.022,7.022,0,0,1,.315,2.1v85.907C1068.069,7739.325,1068.064,7739.44,1068.055,7739.553Z",
    fill: "#000c1c",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1462",
    "data-name": "\\uADF8\\uB8F9 1462"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3029",
    "data-name": "\\uD328\\uC2A4 3029",
    d: "M1067.586,7739.589h-7.325a.738.738,0,0,1-.76-.714v2.821a.76.76,0,0,0,.76.76h7.325a3.247,3.247,0,0,0,3.247-3.247v-2.671A3.154,3.154,0,0,1,1067.586,7739.589Z",
    fill: "#000c1c",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3030",
    "data-name": "\\uD328\\uC2A4 3030",
    d: "M1065.341,7647.81h-5.08a.759.759,0,0,0-.76.76v2.821a.738.738,0,0,1,.76-.714h5.08a5.334,5.334,0,0,1,5.492,5.16V7653.3A5.492,5.492,0,0,0,1065.341,7647.81Z",
    fill: "#fff",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_563",
    "data-name": "\\uC0AC\\uAC01\\uD615 563",
    width: 0.619,
    height: 93.126,
    transform: "translate(1058.881 7648.57)",
    fill: "#41505f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3031",
    "data-name": "\\uD328\\uC2A4 3031",
    d: "M1006.187,7648.421l-1.562,9.517a32.15,32.15,0,0,0-.424,5.2v76a2.442,2.442,0,0,0,.786,1.8l1.41,1.3Z",
    fill: "#9ea9b4"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1464",
    "data-name": "\\uADF8\\uB8F9 1464",
    transform: "translate(0 -6914)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3032",
    "data-name": "\\uD328\\uC2A4 3032",
    d: "M1058.873,7666.639a19.277,19.277,0,0,1,4.982-12.742,19.491,19.491,0,0,1,10.024-6.114c.364-.092.53-.223.495-.634-.047-.536,0-1.079-.015-1.618a1.27,1.27,0,0,1,.636-1.279,1.343,1.343,0,0,1,1.467.15q3.5,2.268,7.007,4.524c1.075.694,2.154,1.383,3.225,2.086a1.251,1.251,0,0,1-.019,2.3q-5.1,3.289-10.2,6.573a1.323,1.323,0,0,1-1.46.175,1.291,1.291,0,0,1-.661-1.314c.017-.539-.019-1.081.011-1.619.021-.369-.116-.466-.461-.431a17.373,17.373,0,0,0-5.266,1.3,12.244,12.244,0,0,0-7.608,9.842,17.57,17.57,0,0,0-.108,3.331c.013.444-.1.772-.587.843s-.707-.216-.82-.633A18.044,18.044,0,0,1,1058.873,7666.639Z",
    fill: "#ff4b27"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1465",
    "data-name": "\\uADF8\\uB8F9 1465",
    transform: "translate(0 -6914)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3033",
    "data-name": "\\uD328\\uC2A4 3033",
    d: "M1057.873,7684.639a19.277,19.277,0,0,1,4.982-12.742,19.491,19.491,0,0,1,10.024-6.114c.364-.092.53-.223.495-.634-.047-.536,0-1.079-.015-1.618a1.27,1.27,0,0,1,.636-1.279,1.343,1.343,0,0,1,1.467.15q3.5,2.268,7.007,4.524c1.075.694,2.154,1.383,3.225,2.086a1.251,1.251,0,0,1-.019,2.3q-5.1,3.289-10.2,6.573a1.323,1.323,0,0,1-1.46.175,1.291,1.291,0,0,1-.661-1.314c.017-.539-.019-1.081.011-1.619.021-.369-.116-.466-.461-.431a17.373,17.373,0,0,0-5.266,1.3,12.244,12.244,0,0,0-7.608,9.842,17.57,17.57,0,0,0-.108,3.331c.013.444-.1.772-.587.843s-.707-.216-.82-.633A18.044,18.044,0,0,1,1057.873,7684.639Z",
    fill: "#ff4b27"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1466",
    "data-name": "\\uADF8\\uB8F9 1466",
    transform: "translate(0 -6914)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3034",
    "data-name": "\\uD328\\uC2A4 3034",
    d: "M1058.873,7725.477a19.278,19.278,0,0,0,4.982,12.742,19.494,19.494,0,0,0,10.024,6.114c.364.092.53.223.495.634-.047.536,0,1.079-.015,1.618a1.27,1.27,0,0,0,.636,1.279,1.341,1.341,0,0,0,1.467-.15q3.5-2.268,7.007-4.524c1.075-.694,2.154-1.383,3.225-2.086a1.251,1.251,0,0,0-.019-2.3q-5.1-3.29-10.2-6.573a1.324,1.324,0,0,0-1.46-.175,1.291,1.291,0,0,0-.661,1.314c.017.539-.019,1.081.011,1.619.021.369-.116.466-.461.431a17.358,17.358,0,0,1-5.266-1.3,12.244,12.244,0,0,1-7.608-9.842,17.565,17.565,0,0,1-.108-3.331c.013-.444-.1-.772-.587-.843s-.707.216-.82.633A18.05,18.05,0,0,0,1058.873,7725.477Z",
    fill: "#ff4b27"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1467",
    "data-name": "\\uADF8\\uB8F9 1467",
    transform: "translate(0 -6914)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3035",
    "data-name": "\\uD328\\uC2A4 3035",
    d: "M1057.873,7701.477a19.278,19.278,0,0,0,4.982,12.742,19.494,19.494,0,0,0,10.024,6.114c.364.092.53.223.495.634-.047.536,0,1.079-.015,1.618a1.27,1.27,0,0,0,.636,1.279,1.341,1.341,0,0,0,1.467-.15q3.5-2.268,7.007-4.524c1.075-.694,2.154-1.383,3.225-2.086a1.251,1.251,0,0,0-.019-2.3q-5.1-3.29-10.2-6.573a1.324,1.324,0,0,0-1.46-.175,1.291,1.291,0,0,0-.661,1.314c.017.539-.019,1.081.011,1.619.021.369-.116.466-.461.431a17.358,17.358,0,0,1-5.266-1.3,12.244,12.244,0,0,1-7.608-9.842,17.565,17.565,0,0,1-.108-3.331c.013-.444-.1-.772-.587-.843s-.707.216-.82.633A18.05,18.05,0,0,0,1057.873,7701.477Z",
    fill: "#ff4b27"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholder4);
export default __webpack_public_path__ + "static/media/placeholder4.9291e915ce56d79a27fa093d3463f2c0.svg";
export { ForwardRef as ReactComponent };